{
  "about.blocks": "Freastalaithe modhnaithe",
  "about.contact": "Teagmháil:",
  "about.default_locale": "Réamhshocrú",
  "about.disclaimer": "Bogearra foinse oscailte saor in aisce is ea Mastodon, agus is le Mastodon gGmbH an trádmharc.",
  "about.domain_blocks.no_reason_available": "Cúis nach bhfuil ar fáil",
  "about.domain_blocks.preamble": "Go ginearálta, tugann Mastodon deis duit ábhar a fheiceáil ó aon fhreastalaí eile sa fediverse agus idirghníomhú leo. Seo iad na heisceachtaí atá déanta ar an bhfreastalaí seo.",
  "about.domain_blocks.silenced.explanation": "Go hiondúil ní fheicfidh tú próifílí ná inneachar ón bhfreastalaí seo, ach amháin má bhíonn tú á lorg nó má ghlacann tú lena leanúint d'aon ghnó.",
  "about.domain_blocks.silenced.title": "Teoranta",
  "about.domain_blocks.suspended.explanation": "Ní dhéanfar aon sonra ón fhreastalaí seo a phróiseáil, a stóráil ná a mhalartú, rud a fhágann nach féidir aon teagmháil ná aon chumarsáid a dhéanamh le húsáideoirí ón fhreastalaí seo.",
  "about.domain_blocks.suspended.title": "Ar fionraí",
  "about.language_label": "Teanga",
  "about.not_available": "Níor cuireadh an t-eolas seo ar fáil ar an bhfreastalaí seo.",
  "about.powered_by": "Meáin shóisialta díláraithe faoi chumhacht {mastodon}",
  "about.rules": "Rialacha an fhreastalaí",
  "account.account_note_header": "Nóta pearsanta",
  "account.activity": "Gníomhaíocht",
  "account.add_note": "Cuir nóta pearsanta leis",
  "account.add_or_remove_from_list": "Cuir Le nó Bain De na liostaí",
  "account.badges.admin": "Riarthóir",
  "account.badges.blocked": "Blocáilte",
  "account.badges.bot": "Uathoibrithe",
  "account.badges.domain_blocked": "Fearann ​​blocáilte",
  "account.badges.group": "Grúpa",
  "account.badges.muted": "Balbhaithe",
  "account.badges.muted_until": "Ar tost go dtí {until}",
  "account.block": "Bac @{name}",
  "account.block_domain": "Bac ainm fearainn {domain}",
  "account.block_short": "Bac",
  "account.blocked": "Bactha",
  "account.cancel_follow_request": "Cealaigh leanúint",
  "account.copy": "Cóipeáil nasc chuig an bpróifíl",
  "account.direct": "Luaigh @{name} go príobháideach",
  "account.disable_notifications": "Stop ag cur in iúl dom nuair a dhéanann @{name} postáil",
  "account.edit_note": "Cuir nóta pearsanta in eagar",
  "account.edit_profile": "Cuir an phróifíl in eagar",
  "account.edit_profile_short": "Cuir in Eagar",
  "account.enable_notifications": "Cuir mé in eol nuair bpostálann @{name}",
  "account.endorse": "Cuir ar an phróifíl mar ghné",
  "account.familiar_followers_many": "Ina dhiaidh sin ag {name1}, {name2}, agus {othersCount, plural, \n    one {duine eile atá aithnid duit} \n    two {# duine eile atá aithnid duit} \n    few {# dhuine eile atá aithnid duit} \n    many {# nduine eile atá aithnid duit} \n    other {# duine eile atá aithnid duit}}",
  "account.familiar_followers_one": "Ina dhiaidh sin {name1}",
  "account.familiar_followers_two": "Ina dhiaidh sin tá {name1} agus {name2}",
  "account.featured": "Faoi thrácht",
  "account.featured.accounts": "Próifílí",
  "account.featured.collections": "Bailiúcháin",
  "account.featured.new_collection": "Bailiúchán nua",
  "account.field_overflow": "Taispeáin an t-ábhar iomlán",
  "account.filters.all": "Gach gníomhaíocht",
  "account.filters.boosts_toggle": "Taispeáin borradh",
  "account.filters.posts_boosts": "Poist agus borradh",
  "account.filters.posts_only": "Poist",
  "account.filters.posts_replies": "Poist agus freagraí",
  "account.filters.replies_toggle": "Taispeáin freagraí",
  "account.follow": "Lean",
  "account.follow_back": "Lean ar ais",
  "account.follow_back_short": "Lean ar ais",
  "account.follow_request": "Iarratas chun leanúint",
  "account.follow_request_cancel": "Cealaigh an t-iarratas",
  "account.follow_request_cancel_short": "Cealaigh",
  "account.follow_request_short": "Iarratas",
  "account.followers": "Leantóirí",
  "account.followers.empty": "Ní leanann éinne an t-úsáideoir seo fós.",
  "account.followers_counter": "{count, plural, one {{counter} leantóir} other {{counter} leantóirí}}",
  "account.followers_you_know_counter": "{counter} tá a fhios agat",
  "account.following": "Ag leanúint",
  "account.following_counter": "{count, plural, one {{counter} ag leanúint} other {{counter} ag leanúint}}",
  "account.follows.empty": "Ní leanann an t-úsáideoir seo aon duine go fóill.",
  "account.follows_you": "Leanann tú",
  "account.go_to_profile": "Téigh go dtí próifíl",
  "account.hide_reblogs": "Folaigh moltaí ó @{name}",
  "account.in_memoriam": "Ón tseanaimsir.",
  "account.join_modal.day": "Lá",
  "account.join_modal.me": "Chuaigh tú isteach i {server} ar",
  "account.join_modal.me_anniversary": "Lá Féile sona duit! Chuaigh tú isteach i {server} ar",
  "account.join_modal.me_today": "Seo é do chéad lá ar {server}!",
  "account.join_modal.other": "Chuaigh {name} isteach i {server} ar",
  "account.join_modal.other_today": "Seo é an chéad lá ag {name} ar {server}!",
  "account.join_modal.share.celebrate": "Roinn post ceiliúrtha",
  "account.join_modal.share.intro": "Comhroinn post réamhrá",
  "account.join_modal.share.welcome": "Roinn post fáilte",
  "account.join_modal.years": "{number, plural, one {bliain} two {blianta} few {blianta} many {blianta} other {blianta}}",
  "account.joined_short": "Cláraithe",
  "account.languages": "Athraigh teangacha foscríofa",
  "account.last_active": "Gníomhach deireanach",
  "account.link_verified_on": "Seiceáladh úinéireacht an naisc seo ar {date}",
  "account.locked_info": "Tá an socrú príobháideachais don cuntas seo curtha go 'faoi ghlas'. Déanann an t-úinéir léirmheas ar cén daoine atá ceadaithe an cuntas leanúint.",
  "account.media": "Meáin",
  "account.mention": "Luaigh @{name}",
  "account.menu.add_to_list": "Cuir leis an liosta…",
  "account.menu.block": "Cuntas blocáilte",
  "account.menu.block_domain": "Blocáil {domain}",
  "account.menu.copied": "Cóipeáladh nasc an chuntais chuig an ghearrthaisce",
  "account.menu.copy": "Cóipeáil nasc",
  "account.menu.direct": "Luaigh go príobháideach",
  "account.menu.hide_reblogs": "Folaigh borradh sa líne ama",
  "account.menu.mention": "Luaigh",
  "account.menu.mute": "Balbhaigh cuntas",
  "account.menu.note.description": "Le feiceáil agatsa amháin",
  "account.menu.open_original_page": "Féach ar {domain}",
  "account.menu.remove_follower": "Bain leantóir",
  "account.menu.report": "Tuairiscigh cuntas",
  "account.menu.share": "Comhroinn…",
  "account.menu.show_reblogs": "Taispeáin borradh san amlíne",
  "account.menu.unblock": "Díbhlocáil cuntas",
  "account.menu.unblock_domain": "Díbhlocáil {domain}",
  "account.menu.unmute": "Díbholg an cuntas",
  "account.moved_to": "Tá tugtha le fios ag {name} gurb é an cuntas nua atá acu ná:",
  "account.mute": "Balbhaigh @{name}",
  "account.mute_notifications_short": "Balbhaigh fógraí",
  "account.mute_short": "Balbhaigh",
  "account.muted": "Balbhaithe",
  "account.mutual": "Leanann sibh a chéile",
  "account.name.copy": "Láimhseáil chóipeála",
  "account.name.help.domain": "Is é {domain} an freastalaí a óstálann próifíl agus poist an úsáideora.",
  "account.name.help.domain_self": "Is é {domain} an freastalaí a óstálann do phróifíl agus do phoist.",
  "account.name.help.footer": "Díreach mar is féidir leat ríomhphoist a sheoladh chuig daoine a úsáideann soláthraithe ríomhphoist éagsúla, is féidir leat idirghníomhú le daoine ar fhreastalaithe Mastodon eile, agus le haon duine ar aipeanna Fediverse eile.",
  "account.name.help.header": "Is cosúil le seoladh ríomhphoist é láimhseáil",
  "account.name.help.username": "Is é {username} ainm úsáideora an chuntais seo ar a bhfreastalaí. D’fhéadfadh an t-ainm úsáideora céanna a bheith ag duine éigin ar fhreastalaí eile.",
  "account.name.help.username_self": "Is é {username} d'ainm úsáideora ar an bhfreastalaí seo. D'fhéadfadh an t-ainm úsáideora céanna a bheith ag duine éigin ar fhreastalaí eile.",
  "account.name_info": "Cad is brí leis seo?",
  "account.no_bio": "Níor tugadh tuairisc.",
  "account.node_modal.callout": "Ní féidir ach leatsa nótaí pearsanta a fheiceáil.",
  "account.node_modal.edit_title": "Cuir nóta pearsanta in eagar",
  "account.node_modal.error_unknown": "Níorbh fhéidir an nóta a shábháil",
  "account.node_modal.field_label": "Nóta Pearsanta",
  "account.node_modal.save": "Sábháil",
  "account.node_modal.title": "Cuir nóta pearsanta leis",
  "account.note.edit_button": "Eagar",
  "account.note.title": "Nóta pearsanta (le feiceáil agatsa amháin)",
  "account.open_original_page": "Oscail an leathanach bunaidh",
  "account.pending": "Ar feitheamh",
  "account.posts": "Postálacha",
  "account.remove_from_followers": "Bain {name} de na leantóirí",
  "account.report": "Tuairiscigh @{name}",
  "account.requested_follow": "D'iarr {name} ort do chuntas a leanúint",
  "account.share": "Roinn próifíl @{name}",
  "account.show_reblogs": "Taispeáin moltaí ó @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} post} other {{counter} poist}}",
  "account.timeline.pinned": "Priontáilte",
  "account.timeline.pinned.view_all": "Féach ar na poist uile atá bioráilte",
  "account.unblock": "Bain bac de @{name}",
  "account.unblock_domain": "Bain bac den ainm fearainn {domain}",
  "account.unblock_domain_short": "Díbhlocáil",
  "account.unblock_short": "Díbhlocáil",
  "account.unendorse": "Ná chuir ar an phróifíl mar ghné",
  "account.unfollow": "Ná lean a thuilleadh",
  "account.unmute": "Díbhalbhaigh @{name}",
  "account.unmute_notifications_short": "Díbhalbhaigh fógraí",
  "account.unmute_short": "Díbhalbhaigh",
  "account_edit.advanced_settings.bot_hint": "Tabhair comhartha do dhaoine eile go ndéanann an cuntas gníomhartha uathoibrithe den chuid is mó agus nach bhféadfadh sé go ndéantar monatóireacht air",
  "account_edit.advanced_settings.bot_label": "Cuntas uathoibrithe",
  "account_edit.advanced_settings.title": "Socruithe ardleibhéil",
  "account_edit.bio.add_label": "Cuir beathaisnéis leis",
  "account_edit.bio.edit_label": "Cuir beathaisnéis in eagar",
  "account_edit.bio.placeholder": "Cuir réamhrá gearr leis chun cabhrú le daoine eile tú a aithint.",
  "account_edit.bio.title": "Beathaisnéis",
  "account_edit.bio_modal.add_title": "Cuir beathaisnéis leis",
  "account_edit.bio_modal.edit_title": "Cuir beathaisnéis in eagar",
  "account_edit.column_button": "Déanta",
  "account_edit.column_title": "Cuir Próifíl in Eagar",
  "account_edit.custom_fields.add_label": "Cuir réimse leis",
  "account_edit.custom_fields.edit_label": "Cuir réimse in eagar",
  "account_edit.custom_fields.placeholder": "Cuir do fhorainmneacha, naisc sheachtracha, nó aon rud eile ar mhaith leat a roinnt leis.",
  "account_edit.custom_fields.reorder_button": "Athordaigh réimsí",
  "account_edit.custom_fields.tip_content": "Is féidir leat creidiúnacht a chur le do chuntas Mastodon go héasca trí naisc chuig aon suíomhanna Gréasáin ar leatsa iad a fhíorú.",
  "account_edit.custom_fields.tip_title": "Leid: Ag cur naisc fhíoraithe leis",
  "account_edit.custom_fields.title": "Réimsí saincheaptha",
  "account_edit.custom_fields.verified_hint": "Conas a chuirim nasc fíoraithe leis?",
  "account_edit.display_name.add_label": "Cuir ainm taispeána leis",
  "account_edit.display_name.edit_label": "Cuir ainm taispeána in eagar",
  "account_edit.display_name.placeholder": "Is é d’ainm taispeána an chaoi a bhfeictear d’ainm ar do phróifíl agus in amlínte.",
  "account_edit.display_name.title": "Ainm taispeána",
  "account_edit.featured_hashtags.edit_label": "Cuir haischlibanna leis",
  "account_edit.featured_hashtags.placeholder": "Cabhraigh le daoine eile do thopaicí is fearr leat a aithint, agus rochtain thapa a bheith acu orthu.",
  "account_edit.featured_hashtags.title": "Haischlibeanna Réadmhaoine",
  "account_edit.field_actions.delete": "Scrios réimse",
  "account_edit.field_actions.edit": "Cuir réimse in eagar",
  "account_edit.field_delete_modal.confirm": "An bhfuil tú cinnte gur mhaith leat an réimse saincheaptha seo a scriosadh? Ní féidir an gníomh seo a chealú.",
  "account_edit.field_delete_modal.delete_button": "Scrios",
  "account_edit.field_delete_modal.title": "An bhfuil fonn ort an réimse saincheaptha a scriosadh?",
  "account_edit.field_edit_modal.add_title": "Cuir réimse saincheaptha leis",
  "account_edit.field_edit_modal.discard_confirm": "Caith uait",
  "account_edit.field_edit_modal.discard_message": "Tá athruithe neamhshábháilte agat. An bhfuil tú cinnte gur mian leat iad a chaitheamh amach?",
  "account_edit.field_edit_modal.edit_title": "Cuir réimse saincheaptha in eagar",
  "account_edit.field_edit_modal.length_warning": "Sáraíodh an teorainn carachtar molta. B’fhéidir nach bhfeicfeadh úsáideoirí soghluaiste do réimse ina iomláine.",
  "account_edit.field_edit_modal.link_emoji_warning": "Molaimid gan emoji saincheaptha a úsáid i gcomhar le Urlanna. Taispeánfar réimsí saincheaptha ina bhfuil an dá cheann mar théacs amháin seachas mar nasc, chun mearbhall úsáideoirí a sheachaint.",
  "account_edit.field_edit_modal.name_hint": "M.sh. “Suíomh Gréasáin pearsanta”",
  "account_edit.field_edit_modal.name_label": "Lipéad",
  "account_edit.field_edit_modal.url_warning": "Chun nasc a chur leis, cuir {protocol} ag an tús le do thoil.",
  "account_edit.field_edit_modal.value_hint": "M.sh. “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Luach",
  "account_edit.field_reorder_modal.drag_cancel": "Cuireadh an tarraingt ar ceal. Baineadh an réimse \"{item}\".",
  "account_edit.field_reorder_modal.drag_end": "Baineadh an réimse \"{item}\".",
  "account_edit.field_reorder_modal.drag_instructions": "Chun réimsí saincheaptha a athshocrú, brúigh spás nó enter. Agus tú ag tarraingt, bain úsáid as na heochracha saigheada chun an réimse a bhogadh suas nó síos. Brúigh spás nó enter arís chun an réimse a scaoileadh ina shuíomh nua, nó brúigh escape chun cealú.",
  "account_edit.field_reorder_modal.drag_move": "Bogadh an réimse \"{item}\".",
  "account_edit.field_reorder_modal.drag_over": "Bogadh réimse \"{item}\" thar \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Réimse \"{item}\" bailithe.",
  "account_edit.field_reorder_modal.handle_label": "Tarraing réimse \"{item}\"",
  "account_edit.field_reorder_modal.title": "Athshocraigh réimsí",
  "account_edit.image_alt_modal.add_title": "Cuir téacs malartach leis",
  "account_edit.image_alt_modal.details_content": "DÉAN: <ul> <li>Déan cur síos ort féin mar atá sa phictiúr</li> <li>Úsáid teanga an tríú pearsa (m.sh. “Alex” in ionad “mise”)</li> <li>Bí gonta – is minic a bhíonn cúpla focal leordhóthanach</li> </ul> NÁ DÉAN: <ul> <li>Tosaigh le “Grianghraf de” – tá sé iomarcach do léitheoirí scáileáin</li> </ul> SAMPLA: <ul> <li>“Alex ag caitheamh léine ghlas agus spéaclaí”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Leideanna: Téacs malartach do ghrianghraif phróifíle",
  "account_edit.image_alt_modal.edit_title": "Cuir téacs alt in eagar",
  "account_edit.image_alt_modal.text_hint": "Cuidíonn téacs malartach le húsáideoirí léitheoirí scáileáin d’ábhar a thuiscint.",
  "account_edit.image_alt_modal.text_label": "Téacs malartach",
  "account_edit.image_delete_modal.confirm": "An bhfuil tú cinnte gur mian leat an íomhá seo a scriosadh? Ní féidir an gníomh seo a chealú.",
  "account_edit.image_delete_modal.delete_button": "Scrios",
  "account_edit.image_delete_modal.title": "Íomhá a scriosadh?",
  "account_edit.image_edit.add_button": "Cuir íomhá leis",
  "account_edit.image_edit.alt_add_button": "Cuir téacs alt leis",
  "account_edit.image_edit.alt_edit_button": "Cuir téacs alt in eagar",
  "account_edit.image_edit.remove_button": "Bain íomhá",
  "account_edit.image_edit.replace_button": "Athsholáthair íomhá",
  "account_edit.item_list.delete": "Scrios {name}",
  "account_edit.item_list.edit": "Cuir {name} in eagar",
  "account_edit.name_modal.add_title": "Cuir ainm taispeána leis",
  "account_edit.name_modal.edit_title": "Cuir ainm taispeána in eagar",
  "account_edit.profile_tab.button_label": "Saincheap",
  "account_edit.profile_tab.hint.description": "Saincheapann na socruithe seo a bhfeiceann úsáideoirí ar {server} sna haipeanna oifigiúla, ach ní fhéadfaidh siad a bheith infheidhme maidir le húsáideoirí ar fhreastalaithe eile agus ar aipeanna tríú páirtí.",
  "account_edit.profile_tab.hint.title": "Bíonn taispeántais fós éagsúil",
  "account_edit.profile_tab.show_featured.description": "Is cluaisín roghnach é ‘Molta’ inar féidir leat cuntais eile a thaispeáint.",
  "account_edit.profile_tab.show_featured.title": "Taispeáin an cluaisín 'Molta'",
  "account_edit.profile_tab.show_media.description": "Is cluaisín roghnach é ‘Meáin’ a thaispeánann do phoist ina bhfuil íomhánna nó físeáin.",
  "account_edit.profile_tab.show_media.title": "Taispeáin an cluaisín ‘Meáin’",
  "account_edit.profile_tab.show_media_replies.description": "Nuair a bhíonn sé cumasaithe, taispeánann an cluaisín Meáin do phoist agus freagraí ar phoist daoine eile araon.",
  "account_edit.profile_tab.show_media_replies.title": "Cuir freagraí san áireamh ar an táb ‘Meáin’",
  "account_edit.profile_tab.show_relations.description": "Taispeáin cuntais a leanann tú agus leantóirí d'úsáideoirí eile i do phróifíl. Beidh daoine fós in ann a fheiceáil an bhfuil tú ag leanúint orthu.",
  "account_edit.profile_tab.show_relations.title": "Taispeáin Leanúna agus iad siúd a Leantar",
  "account_edit.profile_tab.subtitle": "Saincheap conas a thaispeánfar do phróifíl.",
  "account_edit.profile_tab.title": "Socruithe taispeána próifíle",
  "account_edit.save": "Sábháil",
  "account_edit.upload_modal.back": "Ar ais",
  "account_edit.upload_modal.done": "Déanta",
  "account_edit.upload_modal.next": "Ar Aghaidh",
  "account_edit.upload_modal.step_crop.zoom": "Zúmáil",
  "account_edit.upload_modal.step_upload.button": "Brabhsáil comhaid",
  "account_edit.upload_modal.step_upload.dragging": "Scaoil le huaslódáil",
  "account_edit.upload_modal.step_upload.header": "Roghnaigh íomhá",
  "account_edit.upload_modal.step_upload.hint": "Formáid WEBP, PNG, GIF nó JPG, suas le {limit}MB.{br}Scálfar an íomhá go {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Cuir grianghraf próifíle leis",
  "account_edit.upload_modal.title_add.header": "Cuir grianghraf clúdaigh leis",
  "account_edit.upload_modal.title_replace.avatar": "Athsholáthar grianghraf próifíle",
  "account_edit.upload_modal.title_replace.header": "Athsholáthar grianghraf clúdaigh",
  "account_edit.verified_modal.details": "Cuir creidiúnacht le do phróifíl Mastodon trí naisc chuig láithreáin ghréasáin phearsanta a fhíorú. Seo mar a oibríonn sé:",
  "account_edit.verified_modal.invisible_link.details": "Cuir an nasc le do cheanntásc. Is í an chuid thábhachtach ná rel=\"me\" a chuireann cosc ​​ar phearsanú ar shuíomhanna gréasáin a bhfuil inneachar a ghintear ag úsáideoirí. Is féidir leat clib nasc a úsáid fiú i gceanntásc an leathanaigh in ionad {tag}, ach caithfidh an HTML a bheith inrochtana gan JavaScript a chur i gcrích.",
  "account_edit.verified_modal.invisible_link.summary": "Conas a dhéanaim an nasc dofheicthe?",
  "account_edit.verified_modal.step1.header": "Cóipeáil an cód HTML thíos agus greamaigh isteach ceanntásc do shuíomh Gréasáin",
  "account_edit.verified_modal.step2.details": "Má tá do shuíomh Gréasáin curtha leis agat cheana féin mar réimse saincheaptha, beidh ort é a scriosadh agus a chur leis arís chun fíorú a spreagadh.",
  "account_edit.verified_modal.step2.header": "Cuir do shuíomh Gréasáin leis mar réimse saincheaptha",
  "account_edit.verified_modal.title": "Conas nasc fíoraithe a chur leis",
  "account_edit_tags.add_tag": "Cuir #{tagName} leis",
  "account_edit_tags.column_title": "Cuir Clibeanna in Eagar",
  "account_edit_tags.help_text": "Cuidíonn haischlibeanna le húsáideoirí do phróifíl a aimsiú agus idirghníomhú léi. Feictear iad mar scagairí ar radharc Gníomhaíochta do leathanaigh Phróifíle.",
  "account_edit_tags.max_tags_reached": "Tá an líon uasta haischlibanna le feiceáil sroichte agat.",
  "account_edit_tags.search_placeholder": "Cuir isteach haischlib…",
  "account_edit_tags.suggestions": "Moltaí:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# post} two {# poist} few {# poist} many {# poist} other {# poist}}",
  "account_list.hidden_notice": "Níl sé seo le feiceáil ach duit. Chun an liosta seo a thaispeáint do dhaoine eile, téigh chuig <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# cuntas} two {# cuntais} few {# cuntais} many {# cuntais} other {# cuntais}}",
  "account_note.placeholder": "Cliceáil chun nóta a chuir leis",
  "admin.dashboard.daily_retention": "Ráta coinneála an úsáideora de réir an lae tar éis clárú",
  "admin.dashboard.monthly_retention": "Ráta coinneála na n-úsáideoirí de réir na míosa tar éis dóibh clárú",
  "admin.dashboard.retention.average": "Meán",
  "admin.dashboard.retention.cohort": "Mí cláraraithe",
  "admin.dashboard.retention.cohort_size": "Úsáideoirí nua",
  "admin.impact_report.instance_accounts": "Próifílí cuntais a scriosfadh sé seo",
  "admin.impact_report.instance_followers": "Leanúna a chaillfeadh ár n-úsáideoirí",
  "admin.impact_report.instance_follows": "Leanúna a bheadh ​​​​a n-úsáideoirí chailleadh",
  "admin.impact_report.title": "Achoimre ar an tionchar",
  "alert.rate_limited.message": "Atriail aris tar éis {retry_time, time, medium}.",
  "alert.rate_limited.title": "Ráta teoranta",
  "alert.unexpected.message": "Tharla earráid gan choinne.",
  "alert.unexpected.title": "Úps!",
  "alt_text_badge.title": "Téacs alt",
  "alt_text_modal.add_alt_text": "Cuir téacs alt leis",
  "alt_text_modal.add_text_from_image": "Cuir téacs ón íomhá leis",
  "alt_text_modal.cancel": "Cealaigh",
  "alt_text_modal.change_thumbnail": "Athraigh mionsamhail",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Déan cur síos air seo do dhaoine le lagú éisteachta…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Déan cur síos air seo do dhaoine a bhfuil lagú amhairc orthu…",
  "alt_text_modal.done": "Déanta",
  "announcement.announcement": "Fógra",
  "annual_report.announcement.action_build": "Tóg mo Wrapstodon",
  "annual_report.announcement.action_dismiss": "Ní raibh maith agat",
  "annual_report.announcement.action_view": "Féach ar mo Wrapstodon",
  "annual_report.announcement.description": "Faigh tuilleadh eolais faoi do rannpháirtíocht ar Mastodon le bliain anuas.",
  "annual_report.announcement.title": "Tá Wrapstodon {year} tagtha",
  "annual_report.nav_item.badge": "Nua",
  "annual_report.shared_page.donate": "Tabhair Síntiús",
  "annual_report.shared_page.footer": "Gineadh le {heart} ag foireann Mastodon",
  "annual_report.shared_page.footer_server_info": "Úsáideann {username} {domain}, ceann de go leor pobail atá faoi thiomáint ag Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "D’fhan {name} ag cuardach postálacha le cur chun cinn, ag cur le cruthaitheoirí eile le cuspóir foirfe.",
  "annual_report.summary.archetype.booster.desc_self": "D’fhan tú ag cuardach postálacha le borradh a chur fúthu, ag cur le cruthaitheoirí eile le cuspóir foirfe.",
  "annual_report.summary.archetype.booster.name": "An Saighdeoir",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Tá a fhios againn go raibh {name} amuigh ansin, áit éigin, ag baint taitnimh as Mastodon ar a mbealach ciúin féin.",
  "annual_report.summary.archetype.lurker.desc_self": "Tá a fhios againn go raibh tú amuigh ansin, áit éigin, ag baint taitnimh as Mastodon ar do bhealach ciúin féin.",
  "annual_report.summary.archetype.lurker.name": "An Stoiceach",
  "annual_report.summary.archetype.oracle.desc_public": "Chruthaigh {name} níos mó postálacha nua ná freagraí, rud a choinnigh Mastodon úr agus dírithe ar an todhchaí.",
  "annual_report.summary.archetype.oracle.desc_self": "Chruthaigh tú níos mó postálacha nua ná freagraí, rud a choinnigh Mastodon úr agus dírithe ar an todhchaí.",
  "annual_report.summary.archetype.oracle.name": "An tOracal",
  "annual_report.summary.archetype.pollster.desc_public": "Chruthaigh {name} níos mó pobalbhreitheanna ná cineálacha poist eile, rud a chothaigh fiosracht faoi Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Chruthaigh tú níos mó pobalbhreitheanna ná cineálacha poist eile, rud a chothaigh fiosracht ar Mastodon.",
  "annual_report.summary.archetype.pollster.name": "An tIontasóir",
  "annual_report.summary.archetype.replier.desc_public": "Is minic a d’fhreagair {name} poist daoine eile, rud a spreag plé nua i Mastodon.",
  "annual_report.summary.archetype.replier.desc_self": "Is minic a d’fhreagair tú poist daoine eile, ag maolú Mastodon le plé nua.",
  "annual_report.summary.archetype.replier.name": "An Féileacán",
  "annual_report.summary.archetype.reveal": "Nocht mo sheandálaíocht",
  "annual_report.summary.archetype.reveal_description": "Go raibh maith agat as bheith mar chuid de Mastodon! Tá sé in am a fháil amach cén t-archetíopa a léirigh tú i {year}.",
  "annual_report.summary.archetype.title_public": "Seanchineál {name}",
  "annual_report.summary.archetype.title_self": "Do sheandálaíocht",
  "annual_report.summary.close": "Dún",
  "annual_report.summary.copy_link": "Cóipeáil nasc",
  "annual_report.summary.followers.new_followers": "{count, plural, one {leantóir nua} two {leantóirí nua} few {leantóirí nua} many {leantóirí nua} other {leantóirí nua}}",
  "annual_report.summary.highlighted_post.boost_count": "Borradh a tugadh faoin bpost seo {count, plural, one {uair amháin} two {# uaire} few {# uaire} many {# uaire} other {# uaire}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Cuireadh an post seo leis na ceanáin {count, plural, one {uair amháin} two {# uaire} few {# uaire} many {# uaire} other {# uaire}}.",
  "annual_report.summary.highlighted_post.reply_count": "Fuair ​​an post seo {count, plural, one {freagra amháin} two {# freagraí} few {# freagraí} many {# freagraí} other {# freagraí}}.",
  "annual_report.summary.highlighted_post.title": "An post is mó tóir",
  "annual_report.summary.most_used_app.most_used_app": "aip is mó a úsáidtear",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "haischlib is mó a úsáidtear",
  "annual_report.summary.most_used_hashtag.used_count": "Chuir tú an haischlib seo i {count, plural, one {post amháin} two {# poist} few {# poist} many {# poist} other {# poist}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "Chuir {name} an haischlib seo i {count, plural, one {post amháin} two {# poist} few {# poist} many {# poist} other {# poist}}.",
  "annual_report.summary.new_posts.new_posts": "postanna nua",
  "annual_report.summary.percentile.text": "<topLabel>Cuireann sé sin i mbarr</topLabel><percentage></percentage><bottomLabel> úsáideoirí {domain}.</bottomLabel> thú",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Ní inseoidh muid do Bernie.",
  "annual_report.summary.share_elsewhere": "Roinn in áit eile",
  "annual_report.summary.share_message": "Fuair ​​mé an t-archetíopa {archetype}!",
  "annual_report.summary.share_on_mastodon": "Comhroinn ar Mastodon",
  "attachments_list.unprocessed": "(neamhphróiseáilte)",
  "audio.hide": "Cuir fuaim i bhfolach",
  "block_modal.no_collections": "Ní féidir le ceachtar agaibh a chéile a chur le bailiúcháin. Bainfear sibh go huathoibríoch ó bhailiúcháin atá agaibh cheana féin, más infheidhme.",
  "block_modal.remote_users_caveat": "Iarrfaimid ar an bhfreastalaí {domain} meas a bheith agat ar do chinneadh. Mar sin féin, ní ráthaítear comhlíonadh toisc go bhféadfadh roinnt freastalaithe bloic a láimhseáil ar bhealach difriúil. Seans go mbeidh postálacha poiblí fós le feiceáil ag úsáideoirí nach bhfuil logáilte isteach.",
  "block_modal.show_less": "Taispeáin níos lú",
  "block_modal.show_more": "Taispeáin níos mó",
  "block_modal.they_cant_mention": "Ní féidir libh a chéile a lua, a leanúint ná a chéile a lua.",
  "block_modal.they_cant_see_posts": "Ní féidir leo d’ábhar a fheiceáil agus ní fheicfidh tú a gcuid ábhair.",
  "block_modal.they_will_know": "Is féidir leo a fheiceáil go bhfuil bac orthu.",
  "block_modal.title": "Úsáideoir a bhlocáil?",
  "block_modal.you_wont_see_mentions": "Ní fheicfidh tú poist ó dhaoine eile a luann iad.",
  "boost_modal.combo": "Is féidir leat {combo} a bhrú chun é seo a scipeáil an chéad uair eile",
  "boost_modal.reblog": "An post a threisiú?",
  "boost_modal.undo_reblog": "An deireadh a chur le postáil?",
  "bundle_column_error.copy_stacktrace": "Cóipeáil tuairisc earráide",
  "bundle_column_error.error.body": "Ní féidir an leathanach a iarradh a sholáthar. Seans gurb amhlaidh mar gheall ar fhabht sa chód, nó mar gheall ar mhíréireacht leis an mbrabhsálaí.",
  "bundle_column_error.error.title": "Ó, ní hea!",
  "bundle_column_error.network.body": "Tharla earráid agus an leathanach á lódáil. Seans gur mar gheall ar fhadhb shealadach le do nasc idirlín nó i ndáil leis an bhfreastalaí seo atá sé.",
  "bundle_column_error.network.title": "Earráid líonra",
  "bundle_column_error.retry": "Bain triail as arís",
  "bundle_column_error.return": "Téigh ar ais abhaile",
  "bundle_column_error.routing.body": "Ní féidir teacht ar an leathanach a iarradh. An bhfuil tú cinnte go bhfuil an URL sa seoladh i gceart?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Dún",
  "bundle_modal_error.message": "Tharla earráid agus an scáileán seo á lódáil.",
  "bundle_modal_error.retry": "Bain triail as arís",
  "callout.dismiss": "Díbhe",
  "carousel.current": "<sr>Sleamhnán</sr> {current, number} / {max, number}",
  "carousel.slide": "Sleamhnán {current, number} of {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} carachtar molta",
  "character_counter.required": "{currentLength}/{maxLength} carachtar",
  "closed_registrations.other_server_instructions": "Mar rud díláraithe Mastodon, is féidir leat cuntas a chruthú ar seirbheálaí eile ach fós idirghníomhaigh leis an ceann seo.",
  "closed_registrations_modal.description": "Ní féidir cuntas a chruthú ar {domain} faoi láthair, ach cuimhnigh nach gá go mbeadh cuntas agat go sonrach ar {domain} chun Mastodon a úsáid.",
  "closed_registrations_modal.find_another_server": "Faigh freastalaí eile",
  "closed_registrations_modal.preamble": "Ós rud é go bhfuil Mastodon díláraithe, is cuma cá háit a chruthaíonn tú do chuntas, beidh tú in ann idirghníomhú le haon duine ar an bhfreastalaí seo agus iad a leanúint. Is féidir fiú é a féin-óstáil!",
  "closed_registrations_modal.title": "Cláraigh le Mastodon",
  "collection.share_modal.share_link_label": "Roinn an nasc",
  "collection.share_modal.share_via_post": "Postáil ar Mastodon",
  "collection.share_modal.share_via_system": "Comhroinn le…",
  "collection.share_modal.title": "Comhroinn bailiúchán",
  "collection.share_modal.title_new": "Roinn do bhailiúchán nua!",
  "collection.share_template_other": "Féach ar an mbailiúchán fionnuar seo: {link}",
  "collection.share_template_own": "Féach ar mo bhailiúchán nua: {link}",
  "collections.account_count": "{count, plural, one {# cuntas} two {# cuntais} few {# cuntais} many {# cuntais} other {# cuntais}}",
  "collections.accounts.empty_description": "Cuir suas le {count} cuntas leis",
  "collections.accounts.empty_editor_title": "Níl aon duine sa bhailiúchán seo fós",
  "collections.accounts.empty_title": "Tá an bailiúchán seo folamh",
  "collections.block_collection_owner": "Cuntas blocáilte",
  "collections.by_account": "le {account_handle}",
  "collections.collection_description": "Cur síos",
  "collections.collection_language": "Teanga",
  "collections.collection_language_none": "Dada",
  "collections.collection_name": "Ainm",
  "collections.collection_topic": "Topaic",
  "collections.confirm_account_removal": "An bhfuil tú cinnte gur mian leat an cuntas seo a bhaint den bhailiúchán seo?",
  "collections.content_warning": "Rabhadh ábhair",
  "collections.continue": "Lean ar aghaidh",
  "collections.copy_link": "Cóipeáil nasc",
  "collections.copy_link_confirmation": "Cóipeáladh nasc an bhailiúcháin chuig an ghearrthaisce",
  "collections.create.accounts_title": "Cé a bheidh le feiceáil agat sa bhailiúchán seo?",
  "collections.create.basic_details_title": "Sonraí bunúsacha",
  "collections.create.steps": "Céim {step}/{total}",
  "collections.create_collection": "Cruthaigh bailiúchán",
  "collections.delete_collection": "Scrios bailiúchán",
  "collections.description_length_hint": "Teorainn 100 carachtar",
  "collections.detail.author_added_you_on_date": "Chuir {author} leis thú ar {date}",
  "collections.detail.loading": "Ag lódáil an bhailiúcháin…",
  "collections.detail.revoke_inclusion": "Bain mé",
  "collections.detail.sensitive_content": "Ábhar íogair",
  "collections.detail.sensitive_note": "Tá cuntais agus ábhar sa bhailiúchán seo a d'fhéadfadh a bheith íogair do roinnt úsáideoirí.",
  "collections.detail.share": "Comhroinn an bailiúchán seo",
  "collections.detail.you_are_in_this_collection": "Tá tú le feiceáil sa bhailiúchán seo",
  "collections.edit_details": "Cuir sonraí in eagar",
  "collections.error_loading_collections": "Tharla earráid agus na bailiúcháin seo á luchtú.",
  "collections.hidden_accounts_description": "Tá bac nó múchadh déanta agat ar {count, plural, one {an t-úsáideoir seo} two {na húsáideoirí seo} few {na húsáideoirí seo} many {na húsáideoirí seo} other {na húsáideoirí seo}}",
  "collections.hidden_accounts_link": "{count, plural, one {# cuntas folaithe} two {# cuntais folaithe} few {# cuntais folaithe} many {# cuntais folaithe} other {# cuntais folaithe}}",
  "collections.hints.accounts_counter": "cuntais {count}/{max}",
  "collections.last_updated_at": "Nuashonraithe go deireanach: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Bailiúchán} two {# Bailiúcháin} few {# Bailiúcháin} many {# Bailiúcháin} other {# Bailiúcháin}}",
  "collections.list.created_by_author": "Cruthaithe ag {name}",
  "collections.list.created_by_you": "Cruthaithe agatsa",
  "collections.list.featuring_you": "Ag cur san áireamh thú",
  "collections.manage_accounts": "Bainistigh cuntais",
  "collections.mark_as_sensitive": "Marcáil mar íogair",
  "collections.mark_as_sensitive_hint": "Folaíonn sé cur síos agus cuntais an bhailiúcháin taobh thiar de rabhadh ábhair. Beidh ainm an bhailiúcháin le feiceáil fós.",
  "collections.maximum_collection_count_description": "Ceadaíonn do fhreastalaí cruthú suas le {count} bailiúchán.",
  "collections.maximum_collection_count_reached": "Tá an líon uasta bailiúcháin cruthaithe agat",
  "collections.name_length_hint": "Teorainn 40 carachtar",
  "collections.new_collection": "Bailiúchán nua",
  "collections.pending_accounts.message": "Seans go bhfeicfear cuntais mar atá ar feitheamh agus muid ag fanacht ar fhreagra ón úsáideoir nó ón bhfreastalaí. Ní féidir ach leatsa cuntais atá ar feitheamh a fheiceáil.",
  "collections.pending_accounts.title": "Cén fáth a bhfuil cuntais ar feitheamh á bhfaca mé?",
  "collections.remove_account": "Bain",
  "collections.report_collection": "Tuairiscigh an bailiúchán seo",
  "collections.revoke_collection_inclusion": "Bain mé féin as an mbailiúchán seo",
  "collections.revoke_inclusion.confirmation": "Baineadh as \"{collection}\" thú",
  "collections.revoke_inclusion.error": "Tharla earráid, déan iarracht arís ar ball.",
  "collections.search_accounts_label": "Cuardaigh cuntas le cur leis",
  "collections.search_accounts_max_reached": "Tá an líon uasta cuntas curtha leis agat",
  "collections.sensitive": "Íogair",
  "collections.share_short": "Comhroinn",
  "collections.suggestions.can_not_add": "Ní féidir a chur leis",
  "collections.suggestions.can_not_add_desc": "B’fhéidir gur roghnaigh na cuntais seo gan a bheith san fhionnachtain, nó b’fhéidir go bhfuil siad ar fhreastalaí nach dtacaíonn le bailiúcháin.",
  "collections.suggestions.must_follow": "Ní mór leanúint ar dtús",
  "collections.suggestions.must_follow_desc": "Déanann na cuntais seo athbhreithniú ar gach iarratas leantach. Is féidir le leantóirí iad a chur le bailiúcháin.",
  "collections.topic_hint": "Cuir haischlib leis a chabhraíonn le daoine eile príomhábhar an bhailiúcháin seo a thuiscint.",
  "collections.topic_special_chars_hint": "Bainfear carachtair speisialta agus tú ag sábháil",
  "collections.unlisted_collections_description": "Ní fheictear iad seo ar do phróifíl do dhaoine eile. Is féidir le duine ar bith a bhfuil an nasc aige iad a fháil amach.",
  "collections.unlisted_collections_with_count": "Bailiúcháin neamhliostaithe ({count})",
  "collections.view_collection": "Féach ar bhailiúchán",
  "collections.visibility_public": "Poiblí",
  "collections.visibility_public_hint": "Infheicthe i dtorthaí cuardaigh agus i réimsí eile ina bhfuil moltaí le feiceáil.",
  "collections.visibility_title": "Infheictheacht",
  "collections.visibility_unlisted": "Gan liosta",
  "collections.visibility_unlisted_hint": "Infheicthe ag aon duine a bhfuil nasc aige. I bhfolach ó thorthaí cuardaigh agus ó mholtaí.",
  "column.about": "Maidir le",
  "column.blocks": "Úsáideoirí blocáilte",
  "column.bookmarks": "Leabharmharcanna",
  "column.community": "Amlíne áitiúil",
  "column.create_list": "Cruthaigh liosta",
  "column.direct": "Luann príobháideach",
  "column.directory": "Brabhsáil próifílí",
  "column.domain_blocks": "Fearainn bhactha",
  "column.edit_list": "Cuir liosta in eagar",
  "column.favourites": "Ceanáin",
  "column.firehose": "Fothaí beo",
  "column.firehose_local": "Fotha beo don fhreastalaí seo",
  "column.firehose_singular": "Beo-bheatha",
  "column.follow_requests": "Iarratais leanúnaí",
  "column.home": "Baile",
  "column.list_members": "Bainistigh baill liosta",
  "column.lists": "Liostaí",
  "column.mutes": "Úsáideoirí balbhaithe",
  "column.notifications": "Fógraí",
  "column.other_collections": "Bailiúcháin le {name}",
  "column.pins": "Postálacha pionnáilte",
  "column.public": "Amlíne cónaidhmithe",
  "column.your_collections": "Do Bhailiúcháin",
  "column_back_button.label": "Ar ais",
  "column_header.hide_settings": "Folaigh socruithe",
  "column_header.moveLeft_settings": "Bog an colún ar chlé",
  "column_header.moveRight_settings": "Bog an colún ar dheis",
  "column_header.pin": "Pionna",
  "column_header.show_settings": "Taispeáin socruithe",
  "column_header.unpin": "Díbhioráin",
  "column_search.cancel": "Cealaigh",
  "combobox.close_results": "Dún na torthaí",
  "combobox.loading": "Ag luchtú",
  "combobox.no_results_found": "Gan aon torthaí don chuardach seo",
  "combobox.open_results": "Oscail na torthaí",
  "combobox.results_available": "{count, plural, one {# moladh} two {# moltaí} few {# moltaí} many {# moltaí} other {# moltaí}} atá ar fáil. Úsáid na saigheada suas agus síos chun nascleanúint a dhéanamh. Brúigh an eochair Iontráil chun roghnú.",
  "community.column_settings.local_only": "Áitiúil amháin",
  "community.column_settings.media_only": "Meáin Amháin",
  "community.column_settings.remote_only": "Cian amháin",
  "compose.error.blank_post": "Ní féidir an post a fhágáil bán.",
  "compose.language.change": "Athraigh teanga",
  "compose.language.search": "Cuardaigh teangacha...",
  "compose.published.body": "Post foilsithe.",
  "compose.published.open": "Oscail",
  "compose.saved.body": "Postáil sábháilte.",
  "compose_form.direct_message_warning_learn_more": "Tuilleadh eolais",
  "compose_form.encryption_warning": "Ní bhíonn poist ar Mastodon criptithe ó cheann ceann. Ná roinn aon fhaisnéis íogair ar Mastodon.",
  "compose_form.hashtag_warning": "Ní áireofar an teachtaireacht seo faoi haischlib ar bith mar níl sí ar fáil don phobal. Ní féidir ach teachtaireachtaí poiblí a chuardach de réir haischlib.",
  "compose_form.lock_disclaimer": "Níl an cuntas seo {locked}. Féadfaidh duine ar bith tú a leanúint agus na postálacha atá dírithe agat ar do lucht leanúna amháin a fheiceáil.",
  "compose_form.lock_disclaimer.lock": "faoi ghlas",
  "compose_form.placeholder": "Cad atá ar d’intinn?",
  "compose_form.poll.duration": "Fad an vótaíochta",
  "compose_form.poll.multiple": "Ilrogha",
  "compose_form.poll.option_placeholder": "Rogha {number}",
  "compose_form.poll.single": "Rogha aonair",
  "compose_form.poll.switch_to_multiple": "Athraigh suirbhé chun cead a thabhairt do ilrogha",
  "compose_form.poll.switch_to_single": "Athraigh suirbhé chun cead a thabhairt do rogha amháin",
  "compose_form.poll.type": "Stíl",
  "compose_form.publish": "Postáil",
  "compose_form.reply": "Freagra",
  "compose_form.save_changes": "Nuashonrú",
  "compose_form.spoiler.marked": "Bain rabhadh ábhair",
  "compose_form.spoiler.unmarked": "Cuir rabhadh ábhair",
  "compose_form.spoiler_placeholder": "Rabhadh ábhair (roghnach)",
  "confirmation_modal.cancel": "Cealaigh",
  "confirmations.block.confirm": "Bloc",
  "confirmations.delete.confirm": "Scrios",
  "confirmations.delete.message": "An bhfuil tú cinnte gur mhaith leat an phostáil seo a scriosadh?",
  "confirmations.delete.title": "Scrios postáil?",
  "confirmations.delete_collection.confirm": "Scrios",
  "confirmations.delete_collection.message": "Ní féidir an gníomh seo a chealú.",
  "confirmations.delete_collection.title": "Scrios \"{name}\"?",
  "confirmations.delete_list.confirm": "Scrios",
  "confirmations.delete_list.message": "An bhfuil tú cinnte gur mhaith leat an liosta seo a scriosadh go buan?",
  "confirmations.delete_list.title": "Scrios liosta?",
  "confirmations.discard_draft.confirm": "Scrios agus lean ar aghaidh",
  "confirmations.discard_draft.edit.cancel": "Lean an eagarthóireacht",
  "confirmations.discard_draft.edit.message": "Má leanann tú ar aghaidh, cuirfear deireadh le haon athruithe atá déanta agat ar an bpost atá á chur in eagar agat faoi láthair.",
  "confirmations.discard_draft.edit.title": "An bhfuil tú ag iarraidh athruithe ar do phost a chaitheamh amach?",
  "confirmations.discard_draft.post.cancel": "Dréacht atosú",
  "confirmations.discard_draft.post.message": "Má leanann tú ar aghaidh, scriosfar an post atá á scríobh agat faoi láthair.",
  "confirmations.discard_draft.post.title": "An bhfuil tú ag iarraidh do dhréachtphost a chaitheamh amach?",
  "confirmations.discard_edit_media.confirm": "Faigh réidh de",
  "confirmations.discard_edit_media.message": "Tá athruithe neamhshlánaithe don tuarascáil gné nó réamhamharc agat, faigh réidh dóibh ar aon nós?",
  "confirmations.follow_to_list.confirm": "Lean agus cuir leis an liosta",
  "confirmations.follow_to_list.message": "Ní mór duit {name} a leanúint chun iad a chur le liosta.",
  "confirmations.follow_to_list.title": "Lean an t-úsáideoir?",
  "confirmations.hide_featured_tab.confirm": "Folaigh an cluaisín",
  "confirmations.hide_featured_tab.intro": "Is féidir leat é seo a athrú am ar bith faoi <i>Cuir próifíl in eagar > socruithe an chluaisín próifíle</i>.",
  "confirmations.hide_featured_tab.message": "Cuirfidh sé seo an cluaisín i bhfolach d’úsáideoirí ar {serverName} agus freastalaithe eile a bhfuil an leagan is déanaí de Mastodon á rith acu. D’fhéadfadh taispeántais eile a bheith éagsúil.",
  "confirmations.hide_featured_tab.title": "An bhfuil tú ag iarraidh an cluaisín \"Réadmhaoin\" a cheilt?",
  "confirmations.logout.confirm": "Logáil amach",
  "confirmations.logout.message": "An bhfuil tú cinnte gur mhaith leat logáil amach?",
  "confirmations.logout.title": "Logáil amach?",
  "confirmations.missing_alt_text.confirm": "Cuir téacs alt leis",
  "confirmations.missing_alt_text.message": "Tá meáin gan alt téacs i do phostáil. Má chuirtear tuairiscí leis, cabhraíonn sé seo leat d’inneachar a rochtain do níos mó daoine.",
  "confirmations.missing_alt_text.secondary": "Post ar aon nós",
  "confirmations.missing_alt_text.title": "Cuir téacs alt leis?",
  "confirmations.mute.confirm": "Balbhaigh",
  "confirmations.private_quote_notify.cancel": "Ar ais chuig an eagarthóireacht",
  "confirmations.private_quote_notify.confirm": "Foilsigh an post",
  "confirmations.private_quote_notify.do_not_show_again": "Ná taispeáin an teachtaireacht seo dom arís",
  "confirmations.private_quote_notify.message": "Cuirfear an duine atá á lua agat agus luanna eile ar an eolas agus beidh siad in ann do phost a fheiceáil, fiú mura bhfuil siad ag leanúint thú.",
  "confirmations.private_quote_notify.title": "Roinn le leantóirí agus úsáideoirí a luadh?",
  "confirmations.quiet_post_quote_info.dismiss": "Ná cuir i gcuimhne dom arís",
  "confirmations.quiet_post_quote_info.got_it": "Tuigim é",
  "confirmations.quiet_post_quote_info.message": "Agus post poiblí ciúin á lua, beidh do phost i bhfolach ó amlínte treochta.",
  "confirmations.quiet_post_quote_info.title": "Ag lua poist phoiblí chiúine",
  "confirmations.redraft.confirm": "Scrios ⁊ athdhréachtaigh",
  "confirmations.redraft.message": "An bhfuil tú cinnte gur mhaith leat an postáil seo a scriosadh agus é a athdhréachtú? Caillfear ceanáin agus treisithe, agus dílleachtaí freagraí ar an mbunphostála.",
  "confirmations.redraft.title": "Scrios & athdhréachtú postáil?",
  "confirmations.remove_from_followers.confirm": "Bain leantóir",
  "confirmations.remove_from_followers.message": "Scoirfidh {name} de bheith ag leanúint leat. An bhfuil tú cinnte gur mian leat leanúint ar aghaidh?",
  "confirmations.remove_from_followers.title": "Bain an leantóir?",
  "confirmations.revoke_collection_inclusion.confirm": "Bain mé",
  "confirmations.revoke_collection_inclusion.message": "Is gníomh buan é seo, agus ní bheidh an coimeádaí in ann tú a chur leis an mbailiúchán arís níos déanaí.",
  "confirmations.revoke_collection_inclusion.title": "Bain tú féin den bhailiúchán seo?",
  "confirmations.revoke_quote.confirm": "Bain postáil",
  "confirmations.revoke_quote.message": "Ní féidir an gníomh seo a chealú.",
  "confirmations.revoke_quote.title": "Bain postáil?",
  "confirmations.unblock.confirm": "Díbhlocáil",
  "confirmations.unblock.title": "Díbhlocáil {name}?",
  "confirmations.unfollow.confirm": "Ná lean",
  "confirmations.unfollow.title": "Díleanúint {name}?",
  "confirmations.withdraw_request.confirm": "Iarratas ar tharraingt siar",
  "confirmations.withdraw_request.title": "Iarratas chun {name} a leanúint a tharraingt siar?",
  "content_warning.hide": "Folaigh postáil",
  "content_warning.show": "Taispeáin ar aon nós",
  "content_warning.show_more": "Taispeáin níos mó",
  "content_warning.show_short": "Taispeáin",
  "conversation.delete": "Scrios comhrá",
  "conversation.mark_as_read": "Marcáil mar léite",
  "conversation.open": "Féach ar comhrá",
  "conversation.with": "Le {names}",
  "copy_icon_button.copied": "Cóipeáladh chuig an ngearrthaisce",
  "copy_icon_button.copy_this_text": "Cóipeáil nasc chuig an ghearrthaisce",
  "copypaste.copied": "Cóipeáilte",
  "copypaste.copy_to_clipboard": "Cóipeáil chuig an ngearrthaisce",
  "directory.federated": "Ó chomhchruinne aitheanta",
  "directory.local": "Ó {domain} amháin",
  "directory.new_arrivals": "Daoine atá tar éis teacht",
  "directory.recently_active": "Daoine gníomhacha le déanaí",
  "disabled_account_banner.account_settings": "Socruithe cuntais",
  "disabled_account_banner.text": "Tá do chuntas {disabledAccount} díchumasaithe faoi láthair.",
  "dismissable_banner.community_timeline": "Seo iad na postála is déanaí ó dhaoine le cuntais ar {domain}.",
  "dismissable_banner.dismiss": "Diúltaigh",
  "dismissable_banner.public_timeline": "Seo iad na postálacha poiblí is déanaí ó dhaoine ar an bhfealsúnacht a leanann daoine ar {domain}.",
  "domain_block_modal.block": "Bloc freastalaí",
  "domain_block_modal.block_account_instead": "Cuir bac ar @{name} ina ionad sin",
  "domain_block_modal.they_can_interact_with_old_posts": "Is féidir le daoine ón bhfreastalaí seo idirghníomhú le do sheanphoist.",
  "domain_block_modal.they_cant_follow": "Ní féidir le duine ar bith ón bhfreastalaí seo tú a leanúint.",
  "domain_block_modal.they_wont_know": "Ní bheidh a fhios acu go bhfuil bac orthu.",
  "domain_block_modal.title": "Blocáil fearann?",
  "domain_block_modal.you_will_lose_num_followers": "Caillfidh tú {followersCount, plural, one {{followersCountDisplay} leantóir} two {{followersCountDisplay} leantóirí} few {{followersCountDisplay} leantóirí} many {{followersCountDisplay} leantóirí} other {{followersCountDisplay} leantóirí}} agus {followingCount, plural, one {{followingCountDisplay} duine atá á leanúint agat} two {{followingCountDisplay} daoine atá á leanúint agat} few {{followingCountDisplay} daoine atá á leanúint agat} many {{followingCountDisplay} daoine atá á leanúint agat} other {{followingCountDisplay} daoine atá á leanúint agat}}.",
  "domain_block_modal.you_will_lose_relationships": "Caillfidh tú gach leantóir agus duine a leanann tú ón bhfreastalaí seo.",
  "domain_block_modal.you_wont_see_posts": "Ní fheicfidh tú postálacha nó fógraí ó úsáideoirí ar an bhfreastalaí seo.",
  "domain_pill.activitypub_lets_connect": "Ligeann sé duit ceangal agus idirghníomhú le daoine, ní hamháin ar Mastodon, ach thar aipeanna sóisialta éagsúla freisin.",
  "domain_pill.activitypub_like_language": "Tá GníomhaíochtPub cosúil leis an teanga a labhraíonn Mastodon le líonraí sóisialta eile.",
  "domain_pill.server": "Freastalaí",
  "domain_pill.their_handle": "A láimhseáil:",
  "domain_pill.their_server": "A dteach digiteach, áit a bhfuil a gcuid post go léir ina gcónaí.",
  "domain_pill.their_username": "Aitheantóir uathúil ar a bhfreastalaí. Is féidir teacht ar úsáideoirí leis an ainm úsáideora céanna ar fhreastalaithe éagsúla.",
  "domain_pill.username": "Ainm úsáideora",
  "domain_pill.whats_in_a_handle": "Cad atá i láimhseáil?",
  "domain_pill.who_they_are": "Ós rud é go ndeir láimhseálaithe cé hé duine agus cá bhfuil siad, is féidir leat idirghníomhú le daoine ar fud an ghréasáin shóisialta de <button>ardáin atá á gcumhachtú le ActionPub</button>.",
  "domain_pill.who_you_are": "Toisc go ndeir do láimhseáil cé tú féin agus cén áit a bhfuil tú, is féidir le daoine idirghníomhú leat ar fud an ghréasáin shóisialta de <button>ardáin atá á gcumhachtú le ActionPub</button>.",
  "domain_pill.your_handle": "Do láimhseáil:",
  "domain_pill.your_server": "Do theach digiteach, áit a bhfuil do phoist go léir ina gcónaí. Nach maith leat an ceann seo? Aistrigh freastalaithe am ar bith agus tabhair leat do leantóirí freisin.",
  "domain_pill.your_username": "D'aitheantóir uathúil ar an bhfreastalaí seo. Is féidir teacht ar úsáideoirí leis an ainm úsáideora céanna ar fhreastalaithe éagsúla.",
  "dropdown.empty": "Roghnaigh rogha",
  "email_subscriptions.email": "Ríomhphost",
  "email_subscriptions.form.action": "Liostáil",
  "email_subscriptions.form.bottom": "Faigh poist i do bhosca isteach gan cuntas Mastodon a chruthú. Díliostáil ag am ar bith. Le haghaidh tuilleadh eolais, féach ar an <a>Polasaí Príobháideachta</a>.",
  "email_subscriptions.form.title": "Cláraigh le haghaidh nuashonruithe ríomhphoist ó {name}",
  "email_subscriptions.submitted.lead": "Seiceáil do bhosca isteach le haghaidh ríomhphoist chun clárú le haghaidh nuashonruithe ríomhphoist a chríochnú.",
  "email_subscriptions.submitted.title": "Céim amháin eile",
  "email_subscriptions.validation.email.blocked": "Soláthraí ríomhphoist blocáilte",
  "email_subscriptions.validation.email.invalid": "Seoladh ríomhphoist neamhbhailí",
  "embed.instructions": "Embed this status on your website by copying the code below.",
  "embed.preview": "Seo an chuma a bheidh air:",
  "emoji_button.activity": "Gníomhaíocht",
  "emoji_button.clear": "Glan",
  "emoji_button.custom": "Saincheaptha",
  "emoji_button.flags": "Bratacha",
  "emoji_button.food": "Bia ⁊ Ól",
  "emoji_button.label": "Cuir emoji isteach",
  "emoji_button.nature": "Nádur",
  "emoji_button.not_found": "Ní bhfuarthas an cineál emoji sin",
  "emoji_button.objects": "Rudaí",
  "emoji_button.people": "Daoine",
  "emoji_button.recent": "Úsáidte go minic",
  "emoji_button.search": "Cuardaigh...",
  "emoji_button.search_results": "Torthaí cuardaigh",
  "emoji_button.symbols": "Comharthaí",
  "emoji_button.travel": "Taisteal ⁊ Áiteanna",
  "empty_column.account_featured.other": "Níl aon rud le feiceáil ag {acct} go fóill.",
  "empty_column.account_featured_self.no_collections_button": "Cruthaigh bailiúchán",
  "empty_column.account_featured_self.no_collections_hide_tab": "Folaigh an cluaisín seo ina ionad",
  "empty_column.account_featured_self.pre_collections": "Fan tiúnta le haghaidh bailiúcháin",
  "empty_column.account_featured_self.pre_collections_desc": "Le bailiúcháin (atá ag teacht i Mastodon 4.6) is féidir leat do liostaí cuntas féin a chruthú le moladh do dhaoine eile.",
  "empty_column.account_featured_self.showcase_accounts": "Taispeáin do chuntais is fearr leat",
  "empty_column.account_featured_self.showcase_accounts_desc": "Is liostaí coimeádta cuntas iad bailiúcháin chun cabhrú le daoine eile níos mó den Fediverse a fháil amach.",
  "empty_column.account_featured_unknown.other": "Níl aon rud le feiceáil ar an gcuntas seo go fóill.",
  "empty_column.account_hides_collections": "Roghnaigh an t-úsáideoir seo gan an fhaisnéis seo a chur ar fáil",
  "empty_column.account_suspended": "Cuntas ar fionraí",
  "empty_column.account_timeline": "Níl postálacha ar bith anseo!",
  "empty_column.account_unavailable": "Níl an phróifíl ar fáil",
  "empty_column.blocks": "Níl aon úsáideoir bactha agat fós.",
  "empty_column.bookmarked_statuses": "Níl aon phostáil leabharmharcaithe agat fós. Nuair a dhéanann tú leabharmharc, beidh sé le feiceáil anseo.",
  "empty_column.collections.featured_in": "Níor cuireadh le haon bhailiúchán thú go fóill.",
  "empty_column.community": "Tá an amlíne áitiúil folamh. Foilsigh rud éigin go poiblí le tús a chur le cúrsaí!",
  "empty_column.direct": "Níl aon tagairtí príobháideacha agat fós. Nuair a sheolann tú nó a gheobhaidh tú ceann, beidh sé le feiceáil anseo.",
  "empty_column.disabled_feed": "Tá an fotha seo díchumasaithe ag riarthóirí do fhreastalaí.",
  "empty_column.domain_blocks": "Níl aon fearainn bhactha ann go fóill.",
  "empty_column.explore_statuses": "Níl rud ar bith ag treochtáil faoi láthair. Tar ar ais ar ball!",
  "empty_column.favourited_statuses": "Níl aon postálacha is fearr leat fós. Nuair is fearr leat ceann, beidh sé le feiceáil anseo.",
  "empty_column.favourites": "Níor thaitin an post seo le haon duine go fóill. Nuair a dhéanann duine, taispeánfaidh siad suas anseo.",
  "empty_column.follow_requests": "Níl aon phostáil leabharmharcaithe agat fós. Nuair a dhéanann tú leabharmharc, feicfear anseo é.",
  "empty_column.followed_tags": "Níor lean tú aon hashtags fós. Nuair a dhéanann tú, beidh siad a thaispeáint suas anseo.",
  "empty_column.hashtag": "Níl rud ar bith faoin haischlib seo go fóill.",
  "empty_column.home": "Tá d'amlíne baile folamh! B'fhiú duit cúpla duine eile a leanúint lena líonadh! {suggestions}",
  "empty_column.list": "Níl aon rud ar an liosta seo fós. Nuair a fhoilseoidh baill an liosta seo postálacha nua, beidh siad le feiceáil anseo.",
  "empty_column.mutes": "Níl aon úsáideoir balbhaithe agat fós.",
  "empty_column.notification_requests": "Gach soiléir! Níl aon rud anseo. Nuair a gheobhaidh tú fógraí nua, beidh siad le feiceáil anseo de réir do shocruithe.",
  "empty_column.notifications": "Níl aon fógraí agat fós. Nuair a dhéanann daoine eile idirghníomhú leat, feicfear anseo é.",
  "empty_column.public": "Faic anseo! Scríobh rud éigin go poiblí, nó lean úsáideoirí ar fhreastalaithe eile chun é a líonadh",
  "empty_state.no_results": "Gan aon torthaí",
  "error.no_hashtag_feed_access": "Bí linn nó logáil isteach chun an haischlib seo a fheiceáil agus a leanúint.",
  "error.unexpected_crash.explanation": "De bharr fabht inár gcód, nó fadhb le chomhoiriúnacht brabhsálaí, níorbh fhéadfadh an leathanach seo a léiriú i gceart.",
  "error.unexpected_crash.explanation_addons": "Ní taispeántar an leathanach seo mar is ceart. Is dócha go gcruthaíonn breiseán brabhsálaí nó uirlisí uathaistriúcháin an fhadhb seo.",
  "error.unexpected_crash.next_steps": "Bain triail as an leathanach a athnuachan. Mura gcabhraíonn sé sin, seans go mbeidh tú fós in ann Mastodon a úsáid trí bhrabhsálaí nó aip dhúchais eile.",
  "error.unexpected_crash.next_steps_addons": "Déan iarracht iad a dhíchumasú agus an leathanach a athnuachan. Mura gcabhraíonn sé sin, seans go mbeidh tú fós in ann Mastodon a úsáid trí bhrabhsálaí nó aip dhúchais eile.",
  "errors.unexpected_crash.copy_stacktrace": "Cóipeáil rian cruachta go dtí an ghearrthaisce",
  "errors.unexpected_crash.report_issue": "Tuairiscigh deacracht",
  "explore.suggested_follows": "Daoine",
  "explore.title": "Ag treochtáil",
  "explore.trending_links": "Nuacht",
  "explore.trending_statuses": "Postálacha",
  "explore.trending_tags": "Haischlibeanna",
  "featured_carousel.current": "<sr>Post</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Postáil phinnáilte} two {Poist Phionáilte} few {Poist Phionáilte} many {Poist Phionáilte} other {Poist Phionáilte}}",
  "featured_carousel.slide": "Post {current, number} of {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Le déanaí, tá postáil déanta agat faoi {items}. An gcuirfeá iad seo leis mar hashtags le feiceáil?",
  "featured_tags.suggestions.add": "Cuir leis",
  "featured_tags.suggestions.added": "Bainistigh do hashtags le feiceáil ag am ar bith faoi <link>Cuir Próifíl in Eagar > Hashtags le feiceáil</link>.",
  "featured_tags.suggestions.dismiss": "Ní raibh maith agat",
  "filter_modal.added.context_mismatch_explanation": "Ní bhaineann an chatagóir scagaire seo leis an gcomhthéacs ina bhfuair tú rochtain ar an bpostáil seo. Más mian leat an postáil a scagadh sa chomhthéacs seo freisin, beidh ort an scagaire a chur in eagar.",
  "filter_modal.added.context_mismatch_title": "Neamhréir comhthéacs!",
  "filter_modal.added.expired_explanation": "Tá an chatagóir scagaire seo imithe in éag, beidh ort an dáta éaga a athrú chun é a chur i bhfeidhm.",
  "filter_modal.added.expired_title": "Scagaire as feidhm!",
  "filter_modal.added.review_and_configure": "Chun an chatagóir scagaire seo a athbhreithniú agus a chumrú tuilleadh, téigh chuig {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Socruithe scagtha",
  "filter_modal.added.settings_link": "leathan socruithe",
  "filter_modal.added.short_explanation": "Cuireadh an postáil seo leis an gcatagóir scagaire seo a leanas: {title}.",
  "filter_modal.added.title": "Scagaire curtha leis!",
  "filter_modal.select_filter.context_mismatch": "ní bhaineann sé leis an gcomhthéacs seo",
  "filter_modal.select_filter.expired": "imithe in éag",
  "filter_modal.select_filter.prompt_new": "Catagóir nua: {name}",
  "filter_modal.select_filter.search": "Cuardaigh nó cruthaigh",
  "filter_modal.select_filter.subtitle": "Bain úsáid as catagóir reatha nó cruthaigh ceann nua",
  "filter_modal.select_filter.title": "Déan scagadh ar an bpostáil seo",
  "filter_modal.title.status": "Déan scagadh ar phostáil",
  "filter_warning.matches_filter": "Meaitseálann an scagaire “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Ó {count, plural, =0 {duine ar bith} one {duine amháin} two {# daoine} few {# daoine} many {# daoine} other {# daoine}} b’fhéidir go bhfuil aithne agat orthu",
  "filtered_notifications_banner.title": "Fógraí scagtha",
  "firehose.all": "Gach",
  "firehose.local": "An freastalaí seo",
  "firehose.remote": "Freastalaithe eile",
  "follow_request.authorize": "Ceadaigh",
  "follow_request.reject": "Diúltaigh",
  "follow_requests.unlocked_explanation": "Cé nach bhfuil do chuntas faoi ghlas, cheap foireann {domain} gur mhaith leat súil siar ar iarratais leanúnaí as na cuntais seo.",
  "follow_suggestions.curated_suggestion": "Pioc foirne",
  "follow_suggestions.dismiss": "Ná taispeáin arís",
  "follow_suggestions.featured_longer": "Lámh-roghnaithe ag an bhfoireann {domain}",
  "follow_suggestions.friends_of_friends_longer": "Coitianta i measc na ndaoine a leanann tú",
  "follow_suggestions.hints.featured": "Tá an phróifíl seo roghnaithe de láimh ag foireann {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Tá an-tóir ar an bpróifíl seo i measc na ndaoine a leanann tú.",
  "follow_suggestions.hints.most_followed": "Tá an phróifíl seo ar cheann de na cinn is mó a leantar ar {domain}.",
  "follow_suggestions.hints.most_interactions": "Tá an phróifíl seo ag tarraingt go leor airde ar {domain} le déanaí.",
  "follow_suggestions.hints.similar_to_recently_followed": "Tá an phróifíl seo cosúil leis na próifílí a lean tú le déanaí.",
  "follow_suggestions.personalized_suggestion": "Nod pearsantaithe",
  "follow_suggestions.popular_suggestion": "Nod coiteann",
  "follow_suggestions.popular_suggestion_longer": "Tá an-tóir ar {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Cosúil le próifílí a lean tú le déanaí",
  "follow_suggestions.view_all": "Féach uile",
  "follow_suggestions.who_to_follow": "Cé le leanúint",
  "followed_tags": "Hashtags le leanúint",
  "followers.hide_other_followers": "Tá an t-úsáideoir seo tar éis a roghnú gan a leantóirí eile a dhéanamh le feiceáil",
  "followers.title": "Ag leanúint {name}",
  "following.hide_other_following": "Tá an t-úsáideoir seo tar éis a roghnú gan an chuid eile de na daoine a leanann siad a dhéanamh le feiceáil",
  "following.title": "Ag leanúint {name}",
  "footer.about": "Maidir le",
  "footer.about_mastodon": "Maidir le Mastodon",
  "footer.about_server": "Maidir le {domain}",
  "footer.about_this_server": "Maidir",
  "footer.directory": "Eolaire próifílí",
  "footer.get_app": "Faigh an aip",
  "footer.keyboard_shortcuts": "Aicearraí méarchláir",
  "footer.privacy_policy": "Polasaí príobháideachais",
  "footer.source_code": "Féach ar an gcód foinseach",
  "footer.status": "Stádas",
  "footer.terms_of_service": "Téarmaí seirbhíse",
  "form_error.blank": "Ní féidir an réimse a fhágáil bán.",
  "form_field.optional": "(roghnach)",
  "generic.saved": "Sábháilte",
  "getting_started.heading": "Ag tosú amach",
  "hashtag.admin_moderation": "Oscail comhéadan modhnóireachta le haghaidh #{name}",
  "hashtag.browse": "Brabhsáil poist i #{hashtag}",
  "hashtag.browse_from_account": "Brabhsáil poist ó @{name} i #{hashtag}",
  "hashtag.column_header.tag_mode.all": "agus {additional}",
  "hashtag.column_header.tag_mode.any": "nó {additional}",
  "hashtag.column_header.tag_mode.none": "gan {additional}",
  "hashtag.column_settings.select.no_options_message": "Moltaí ar bith faighte",
  "hashtag.column_settings.select.placeholder": "Iontráil haischlibeanna…",
  "hashtag.column_settings.tag_mode.all": "Iad seo go léir",
  "hashtag.column_settings.tag_mode.any": "Aon cheann díobh seo",
  "hashtag.column_settings.tag_mode.none": "Níl aon cheann díobh seo",
  "hashtag.column_settings.tag_toggle": "Cuir clibeanna breise san áireamh don cholún seo",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} rannpháirtí} two {{counter} rannpháirtí} few {{counter} rannpháirtí} many {{counter} rannpháirtí} other {{counter} rannpháirtí}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} post} two {{counter} post} few {{counter} post} many {{counter} post} other {{counter} poist}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} post inniu} other {{counter} poist inniu}} inniu",
  "hashtag.feature": "Gné ar phróifíl",
  "hashtag.follow": "Lean haischlib",
  "hashtag.mute": "Balbhaigh #{hashtag}",
  "hashtag.unfeature": "Ná cuir le feiceáil ar phróifíl",
  "hashtag.unfollow": "Ná lean haischlib",
  "hashtags.and_other": "agus {count, plural, one {} two {# níos} few {# níos} many {# níos} other {# níos}}",
  "hints.profiles.followers_may_be_missing": "Seans go bhfuil leantóirí don phróifíl seo in easnamh.",
  "hints.profiles.follows_may_be_missing": "Seans go bhfuil na nithe seo a leanas in easnamh ar an bpróifíl seo.",
  "hints.profiles.posts_may_be_missing": "Seans go bhfuil roinnt postálacha ón bpróifíl seo in easnamh.",
  "hints.profiles.see_more_followers": "Féach ar a thuilleadh leantóirí ar {domain}",
  "hints.profiles.see_more_follows": "Féach tuilleadh seo a leanas ar {domain}",
  "hints.profiles.see_more_posts": "Féach ar a thuilleadh postálacha ar {domain}",
  "home.column_settings.show_quotes": "Taispeáin sleachta",
  "home.column_settings.show_reblogs": "Taispeáin moltaí",
  "home.column_settings.show_replies": "Taispeán freagraí",
  "home.hide_announcements": "Cuir fógraí i bhfolach",
  "home.pending_critical_update.body": "Nuashonraigh do fhreastalaí Mastodon chomh luath agus is féidir!",
  "home.pending_critical_update.link": "Féach nuashonruithe",
  "home.pending_critical_update.title": "Nuashonrú slándála ríthábhachtach ar fáil!",
  "home.show_announcements": "Taispeáin fógraí",
  "ignore_notifications_modal.disclaimer": "Ní féidir le Mastodon úsáideoirí a chur ar an eolas gur thug tú neamhaird dá bhfógraí. Má dhéantar neamhaird de fhógraí, ní stopfar na teachtaireachtaí iad féin a sheoladh.",
  "ignore_notifications_modal.filter_instead": "Scag ina ionad sin",
  "ignore_notifications_modal.filter_to_act_users": "Beidh tú fós in ann glacadh le húsáideoirí, iad a dhiúltú nó a thuairisciú",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Cuidíonn scagadh le mearbhall a sheachaint",
  "ignore_notifications_modal.filter_to_review_separately": "Is féidir leat fógraí scagtha a athbhreithniú ar leithligh",
  "ignore_notifications_modal.ignore": "Déan neamhaird de fhógraí",
  "ignore_notifications_modal.limited_accounts_title": "An dtugann tú neamhaird d'fhógraí ó chuntais mhodhnaithe?",
  "ignore_notifications_modal.new_accounts_title": "An bhfuil fonn ort neamhaird a dhéanamh d'fhógraí ó chuntais nua?",
  "ignore_notifications_modal.not_followers_title": "An dtugann tú aird ar fhógraí ó dhaoine nach leanann tú?",
  "ignore_notifications_modal.not_following_title": "An ndéanann tú neamhaird de fhógraí ó dhaoine nach leanann tú?",
  "ignore_notifications_modal.private_mentions_title": "An dtugann tú aird ar fhógraí ó Luaintí Príobháideacha gan iarraidh?",
  "info_button.label": "Cabhrú",
  "info_button.what_is_alt_text": "<h1>Cad is téacs altach ann?</h1> <p>Soláthraíonn téacs Alt cur síos ar íomhánna do dhaoine le lagú radhairc, naisc íseal-bandaleithead, nó daoine atá ag lorg comhthéacs breise.</p> <p>Is féidir leat inrochtaineacht agus tuiscint a fheabhsú do chách trí théacs alt soiléir, gonta, oibiachtúil a scríobh.</p> <ul> <li>Glac gnéithe tábhachtacha</li> <li>Déan achoimre ar théacs in íomhánna</li> <li>Úsáid struchtúr abairtí rialta</li> li> <li>Seachain faisnéis iomarcach</li> <li>Fócas ar threochtaí agus ar phríomhthorthaí i bhfíseanna casta (amhail léaráidí nó léarscáileanna)</li> </ul>",
  "interaction_modal.action": "Chun idirghníomhú le post {name}, ní mór duit síniú isteach i do chuntas ar cibé freastalaí Mastodon a úsáideann tú.",
  "interaction_modal.action_follow": "Chun {name} a leanúint, ní mór duit síniú isteach i do chuntas ar cibé freastalaí Mastodon a úsáideann tú.",
  "interaction_modal.go": "Téigh",
  "interaction_modal.no_account_yet": "Níl cuntas agat fós?",
  "interaction_modal.on_another_server": "Ar freastalaí eile",
  "interaction_modal.on_this_server": "Ar an freastalaí seo",
  "interaction_modal.title": "Sínigh isteach le leanúint ar aghaidh",
  "interaction_modal.username_prompt": "M.sh. {example}",
  "intervals.full.days": "{number, plural, one {# lá} other {# lá}}",
  "intervals.full.hours": "{number, plural, one {# uair} other {# uair}}",
  "intervals.full.minutes": "{number, plural, one {# nóiméad} other {# nóiméad}}",
  "keyboard_shortcuts.back": "Nasclean siar",
  "keyboard_shortcuts.blocked": "Oscail liosta na n-úsáideoirí bactha",
  "keyboard_shortcuts.boost": "Treisigh postáil",
  "keyboard_shortcuts.column": "Colún fócas",
  "keyboard_shortcuts.compose": "Fócas a chumadh textarea",
  "keyboard_shortcuts.description": "Cur síos",
  "keyboard_shortcuts.direct": "Oscail colún tráchtanna príobháideacha",
  "keyboard_shortcuts.down": "Bog síos ar an liosta",
  "keyboard_shortcuts.enter": "Oscail postáil",
  "keyboard_shortcuts.explore": "Oscail an amlíne treochta",
  "keyboard_shortcuts.favourite": "Postáil is fearr leat",
  "keyboard_shortcuts.favourites": "Oscail liosta ceanáin",
  "keyboard_shortcuts.federated": "Oscail amlíne cónaidhmithe",
  "keyboard_shortcuts.heading": "Aicearraí méarchláir",
  "keyboard_shortcuts.home": "Oscail amlíne bhaile",
  "keyboard_shortcuts.hotkey": "Eochair aicearra",
  "keyboard_shortcuts.legend": "Taispeáin an finscéal seo",
  "keyboard_shortcuts.load_more": "Dírigh ar an gcnaipe \"Lódáil níos mó\"",
  "keyboard_shortcuts.local": "Oscail an amlíne áitiúil",
  "keyboard_shortcuts.mention": "Luaigh údar",
  "keyboard_shortcuts.muted": "Oscail liosta na n-úsáideoirí balbhaithe",
  "keyboard_shortcuts.my_profile": "Oscail do phróifíl",
  "keyboard_shortcuts.notifications": "Oscail colún fógraí",
  "keyboard_shortcuts.open_media": "Oscail meáin",
  "keyboard_shortcuts.pinned": "Oscail liosta postálacha pinn",
  "keyboard_shortcuts.profile": "Oscail próifíl an t-údar",
  "keyboard_shortcuts.quote": "Postáil luachana",
  "keyboard_shortcuts.reply": "Freagair ar phostáil",
  "keyboard_shortcuts.requests": "Oscail liosta iarratas leanúnaí",
  "keyboard_shortcuts.search": "Díriú ar an mbosca cuardaigh",
  "keyboard_shortcuts.spoilers": "Taispeáin / folaigh réimse CW",
  "keyboard_shortcuts.start": "Oscail an colún “tosaigh”",
  "keyboard_shortcuts.toggle_hidden": "Taispeáin/folaigh an téacs taobh thiar de CW",
  "keyboard_shortcuts.toggle_sensitivity": "Taispeáin / cuir i bhfolach meáin",
  "keyboard_shortcuts.toot": "Cuir tús le postáil nua",
  "keyboard_shortcuts.top": "Bog go barr an liosta",
  "keyboard_shortcuts.translate": "post a aistriú",
  "keyboard_shortcuts.unfocus": "Unfocus cum textarea/search",
  "keyboard_shortcuts.up": "Bog suas ar an liosta",
  "learn_more_link.got_it": "Tuigim é",
  "learn_more_link.learn_more": "Foghlaim níos mó",
  "lightbox.close": "Dún",
  "lightbox.next": "An céad eile",
  "lightbox.previous": "Roimhe seo",
  "lightbox.zoom_in": "Súmáil chuig an méid iarbhír",
  "lightbox.zoom_out": "Súmáil a d'oirfeadh",
  "limited_account_hint.action": "Taispeáin an phróifíl ar aon nós",
  "limited_account_hint.title": "Tá an phróifíl seo curtha i bhfolach ag na modhnóra {domain}.",
  "link_preview.author": "Le {name}",
  "link_preview.more_from_author": "Tuilleadh ó {name}",
  "link_preview.shares": "{count, plural, one {{counter} post} other {{counter} poist}}",
  "lists.add_member": "Cuir",
  "lists.add_to_list": "Cuir leis an liosta",
  "lists.add_to_lists": "Cuir {name} le liostaí",
  "lists.create": "Cruthaigh",
  "lists.create_a_list_to_organize": "Cruthaigh liosta nua chun d'fhotha Baile a eagrú",
  "lists.create_list": "Cruthaigh liosta",
  "lists.delete": "Scrios liosta",
  "lists.done": "Déanta",
  "lists.edit": "Cuir an liosta in eagar",
  "lists.exclusive": "Folaigh baill sa Bhaile",
  "lists.exclusive_hint": "Má tá duine ar an liosta seo, cuir i bhfolach iad i do fhotha Baile ionas nach bhfeicfidh tú a bpoist faoi dhó.",
  "lists.find_users_to_add": "Aimsigh úsáideoirí le cur leis",
  "lists.list_members_count": "{count, plural, one {# ball} two {# bhall} few {# baill} many {# baill} other {# baill}}",
  "lists.list_name": "Ainm an liosta",
  "lists.new_list_name": "Ainm liosta nua",
  "lists.no_lists_yet": "Níl aon liostaí fós.",
  "lists.no_members_yet": "Níl aon bhall fós.",
  "lists.no_results_found": "Níor aimsíodh aon torthaí.",
  "lists.remove_member": "Bain",
  "lists.replies_policy.followed": "Úsáideoir ar bith atá á leanúint",
  "lists.replies_policy.list": "Baill an liosta",
  "lists.replies_policy.none": "Duine ar bith",
  "lists.save": "Sábháil",
  "lists.search": "Cuardach",
  "lists.show_replies_to": "Cuir san áireamh freagraí ó bhaill an liosta go",
  "load_pending": "{count, plural, one {# mír nua} two {# mír nua} few {# mír nua} many {# mír nua} other {# mír nua}}",
  "loading_indicator.label": "Á lódáil…",
  "media_gallery.hide": "Folaigh",
  "moved_to_account_banner.text": "Tá do chuntas {disabledAccount} díchumasaithe faoi láthair toisc gur bhog tú go {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Folaigh ó fhógraí",
  "mute_modal.hide_options": "Folaigh roghanna",
  "mute_modal.indefinite": "Go dtí go ndíbhalfaidh mé iad",
  "mute_modal.show_options": "Taispeáin roghanna",
  "mute_modal.they_can_mention_and_follow": "Is féidir leo tú a lua agus a leanúint, ach ní fheicfidh tú iad.",
  "mute_modal.they_wont_know": "Ní bheidh a fhios acu go bhfuil balbhú orthu.",
  "mute_modal.title": "An bhfuil fonn ort úsáideoir a bhalbhú?",
  "mute_modal.you_wont_see_mentions": "Ní fheicfidh tú postálacha a luann iad.",
  "mute_modal.you_wont_see_posts": "Is féidir leo do phoist a fheiceáil go fóill, ach ní fheicfidh tú a gcuid postanna.",
  "navigation_bar.about": "Maidir le",
  "navigation_bar.account_settings": "Pasfhocal agus slándáil",
  "navigation_bar.administration": "Riarachán",
  "navigation_bar.advanced_interface": "Oscail i gcomhéadan gréasáin chun cinn",
  "navigation_bar.automated_deletion": "Scriosadh uathoibrithe postála",
  "navigation_bar.blocks": "Cuntais bhactha",
  "navigation_bar.bookmarks": "Leabharmharcanna",
  "navigation_bar.collections": "Bailiúcháin",
  "navigation_bar.direct": "Luann príobháideach",
  "navigation_bar.domain_blocks": "Fearainn bhactha",
  "navigation_bar.favourites": "Ceanáin",
  "navigation_bar.filters": "Focail bhalbhaithe",
  "navigation_bar.follow_requests": "Iarratais leanúnaí",
  "navigation_bar.followed_tags": "Haischlibeanna ina dhiaidh",
  "navigation_bar.follows_and_followers": "Ag leanúint agus do do leanúint",
  "navigation_bar.import_export": "Allmhairiú agus onnmhairiú",
  "navigation_bar.lists": "Liostaí",
  "navigation_bar.live_feed_local": "Fotha beo (áitiúil)",
  "navigation_bar.live_feed_public": "Fotha beo (poiblí)",
  "navigation_bar.logout": "Logáil Amach",
  "navigation_bar.moderation": "Measarthacht",
  "navigation_bar.more": "Tuilleadh",
  "navigation_bar.mutes": "Úsáideoirí balbhaithe",
  "navigation_bar.opened_in_classic_interface": "Osclaítear poist, cuntais agus leathanaigh shonracha eile de réir réamhshocraithe sa chomhéadan gréasáin clasaiceach.",
  "navigation_bar.preferences": "Sainroghanna pearsanta",
  "navigation_bar.privacy_and_reach": "Príobháideacht agus rochtain",
  "navigation_bar.search": "Cuardaigh",
  "navigation_bar.search_trends": "Cuardaigh / Treochtaí",
  "navigation_panel.collapse_followed_tags": "Laghdaigh roghchlár hashtaganna leantóirí",
  "navigation_panel.collapse_lists": "Laghdaigh roghchlár an liosta",
  "navigation_panel.expand_followed_tags": "Leathnaigh roghchlár na hashtaganna a leanann tú",
  "navigation_panel.expand_lists": "Leathnaigh an roghchlár liosta",
  "not_signed_in_indicator.not_signed_in": "Ní mór duit logáil isteach chun rochtain a fháil ar an acmhainn seo.",
  "notification.added_to_collection": "Chuir {name} le bailiúchán thú",
  "notification.admin.report": "Tuairiscigh {name} {target}",
  "notification.admin.report_account": "{name} thuairiscigh {count, plural, one {aon phost} two {# phost} few {# phost} many {# bpost} other {# bpost}} ó {target} do {category}",
  "notification.admin.report_account_other": "{name} thuairiscigh {count, plural, one {aon phost} two {# phost} few {# phost} many {# bpost} other {# bpost}} ó {target}",
  "notification.admin.report_statuses": "Thuairiscigh {name} {target} le haghaidh {category}",
  "notification.admin.report_statuses_other": "{name} tuairiscithe {target}",
  "notification.admin.sign_up": "Chláraigh {name}",
  "notification.admin.sign_up.name_and_others": "{name} agus {count, plural, one {# duine eile} two {# daoine eile} few {# daoine eile} many {# daoine eile} other {# daoine eile}} a chláraigh",
  "notification.annual_report.message": "Tá do {year} #Wrapstodon ag fanacht! Nocht buaicphointí na bliana agus chuimhneacháin i gcuimhne ar Mastodon!",
  "notification.annual_report.view": "Amharc #Wrapstodon",
  "notification.collection_update": "Chuir {name} bailiúchán ina bhfuil tú in eagar",
  "notification.favourite": "Is fearr le {name} do phostáil",
  "notification.favourite.name_and_others_with_link": "{name} agus <a>{count, plural, one {# duine eile} other {# daoine eile}}</a> thaitin le do phost",
  "notification.favourite_pm": "B'fhearr le {name} do lua príobháideach",
  "notification.favourite_pm.name_and_others_with_link": "{name} agus <a>{count, plural, one {# eile} two {# eile} few {# eile} many {# eile} other {# eile}}</a> atá roghnaithe do do luaidh phríobháideach",
  "notification.follow": "Lean {name} thú",
  "notification.follow.name_and_others": "{name} agus <a>{count, plural, one {# other} two {# eile} few {# eile} many {# eile} other {# others}}</a> lean tú",
  "notification.follow_request": "D'iarr {name} ort do chuntas a leanúint",
  "notification.follow_request.name_and_others": "{name} agus {count, plural, one {# duine eile} other {# daoine eile}} iarratas a dhéanamh chun tú a leanúint",
  "notification.label.mention": "Luaigh",
  "notification.label.private_mention": "Lua príobháideach",
  "notification.label.private_reply": "Freagra príobháideach",
  "notification.label.quote": "Luaigh {name} do phost",
  "notification.label.reply": "Freagra",
  "notification.mention": "Luaigh",
  "notification.mentioned_you": "Luaigh {name} tú",
  "notification.moderation-warning.learn_more": "Foghlaim níos mó",
  "notification.moderation_warning": "Tá rabhadh modhnóireachta faighte agat",
  "notification.moderation_warning.action_delete_statuses": "Baineadh cuid de do phostálacha.",
  "notification.moderation_warning.action_disable": "Díchumasaíodh do chuntas.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Tá cuid de do phostálacha marcáilte mar íogair.",
  "notification.moderation_warning.action_none": "Tá rabhadh modhnóireachta faighte ag do chuntas.",
  "notification.moderation_warning.action_sensitive": "Déanfar do phostálacha a mharcáil mar íogair as seo amach.",
  "notification.moderation_warning.action_silence": "Tá do chuntas teoranta.",
  "notification.moderation_warning.action_suspend": "Cuireadh do chuntas ar fionraí.",
  "notification.own_poll": "Tá do suirbhé críochnaithe",
  "notification.poll": "Tá deireadh le vótaíocht inar vótáil tú",
  "notification.quoted_update": "Chuir {name} post in eagar a luaigh tú",
  "notification.reblog": "Mhol {name} do phostáil",
  "notification.reblog.name_and_others_with_link": "{name} agus <a>{count, plural, one {# duine eile} other {# daoine eile}}</a> a chuir borradh faoi do phost",
  "notification.relationships_severance_event": "Cailleadh naisc le {name}",
  "notification.relationships_severance_event.account_suspension": "Chuir riarthóir ó {from} {target} ar fionraí, rud a chiallaíonn nach féidir leat nuashonruithe a fháil uathu a thuilleadh ná idirghníomhú leo.",
  "notification.relationships_severance_event.domain_block": "Chuir riarthóir ó {from} bac ar {target}, lena n-áirítear {followersCount} de do leantóirí agus {followingCount, plural, one {#cuntas} other {#cuntas}} leanann tú.",
  "notification.relationships_severance_event.learn_more": "Foghlaim níos mó",
  "notification.relationships_severance_event.user_domain_block": "Chuir tú bac ar {target}, bhain tú {followersCount} de do leantóirí agus {followingCount, plural, one {# cuntas} other {# cuntais}} a leanann tú.",
  "notification.status": "Phostáil {name} díreach",
  "notification.update": "Chuir {name} postáil in eagar",
  "notification_requests.accept": "Glac",
  "notification_requests.accept_multiple": "{count, plural, one {Glac le # iarratas…} other {Glac le # iarratais…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Glac le hIarratas} other {Glac le hIarratais}}",
  "notification_requests.confirm_accept_multiple.message": "Tá tú ar tí glacadh le {count, plural, one {iarratas fógra amháin} other {# iarratas fógra}}. An bhfuil tú cinnte gur mian leat leanúint ar aghaidh?",
  "notification_requests.confirm_accept_multiple.title": "Glac le hiarratais ar fhógra?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Dún iarratas} other {Dún iarratais}}",
  "notification_requests.confirm_dismiss_multiple.message": "Tá tú ar tí iarratas fógra {count, plural, one {a hAon} other {#}} a dhúnadh. Ní bheidh tú in ann {count, plural, one {é} other {iad}} a fháil go héasca arís. An bhfuil tú cinnte gur mian leat leanúint ar aghaidh?",
  "notification_requests.confirm_dismiss_multiple.title": "An bhfuil fonn ort iarratais ar fhógra a dhíbhe?",
  "notification_requests.dismiss": "Díbhe",
  "notification_requests.dismiss_multiple": "{count, plural, one {Dún # iarratas…} other {Dún # iarratais…}}",
  "notification_requests.edit_selection": "Cuir in eagar",
  "notification_requests.exit_selection": "Déanta",
  "notification_requests.explainer_for_limited_account": "Scagadh fógraí ón gcuntas seo toisc go bhfuil an cuntas teoranta ag modhnóir.",
  "notification_requests.explainer_for_limited_remote_account": "Scagadh fógraí ón gcuntas seo toisc go bhfuil an cuntas nó a fhreastalaí teoranta ag modhnóir.",
  "notification_requests.maximize": "Uasmhéadaigh",
  "notification_requests.minimize_banner": "Íoslaghdaigh bratach na bhfógraí scagtha",
  "notification_requests.notifications_from": "Fógraí ó {name}",
  "notification_requests.title": "Fógraí scagtha",
  "notification_requests.view": "Féach ar fhógraí",
  "notifications.clear": "Glan fógraí",
  "notifications.clear_confirmation": "An bhfuil tú cinnte gur mhaith leat d'fhógraí go léir a ghlanadh go buan?",
  "notifications.clear_title": "Glan fógraí?",
  "notifications.column_settings.admin.report": "Tuairiscí nua:",
  "notifications.column_settings.admin.sign_up": "Clárúcháin nua:",
  "notifications.column_settings.alert": "Fógraí deisce",
  "notifications.column_settings.favourite": "Ceanáin:",
  "notifications.column_settings.filter_bar.advanced": "Taispeáin gach catagóir",
  "notifications.column_settings.filter_bar.category": "Barra scagairí tapa",
  "notifications.column_settings.follow": "Leantóirí nua:",
  "notifications.column_settings.follow_request": "Iarratais leanúnaí nua:",
  "notifications.column_settings.group": "Grúpa",
  "notifications.column_settings.mention": "Tráchtanna:",
  "notifications.column_settings.poll": "Torthaí suirbhéanna:",
  "notifications.column_settings.push": "Brúfhógraí",
  "notifications.column_settings.quote": "Sleachta:",
  "notifications.column_settings.reblog": "Moltaí:",
  "notifications.column_settings.show": "Taispeáin i gcolún",
  "notifications.column_settings.sound": "Seinn an fhuaim",
  "notifications.column_settings.status": "Postálacha nua:",
  "notifications.column_settings.unread_notifications.category": "Brúfhógraí neamhléite",
  "notifications.column_settings.unread_notifications.highlight": "Aibhsigh fógraí neamhléite",
  "notifications.column_settings.update": "Eagair:",
  "notifications.filter.all": "Uile",
  "notifications.filter.boosts": "Treisithe",
  "notifications.filter.favourites": "Ceanáin",
  "notifications.filter.follows": "Ag leanúint",
  "notifications.filter.mentions": "Tráchtanna",
  "notifications.filter.polls": "Torthaí suirbhéanna",
  "notifications.filter.statuses": "Nuashonruithe ó dhaoine a leanann tú",
  "notifications.grant_permission": "Tabhair cead.",
  "notifications.group": "{count} fógraí",
  "notifications.mark_as_read": "Marcáil gach fógra mar atá léite",
  "notifications.permission_denied": "Níl fógraí deisce ar fáil mar gheall ar iarratas ar chead brabhsálaí a diúltaíodh roimhe seo",
  "notifications.permission_denied_alert": "Ní féidir fógraí deisce a chumasú, mar gur diúltaíodh cead brabhsálaí roimhe seo",
  "notifications.permission_required": "Níl fógraí deisce ar fáil toisc nár tugadh an cead riachtanach.",
  "notifications.policy.accept": "Glac",
  "notifications.policy.accept_hint": "Taispeáin i bhfógraí",
  "notifications.policy.drop": "Déan neamhaird de",
  "notifications.policy.drop_hint": "Seol chuig an neamhní, gan a bheith le feiceáil arís",
  "notifications.policy.filter": "Scagaire",
  "notifications.policy.filter_hint": "Seol chuig an mbosca isteach fógraí scagtha",
  "notifications.policy.filter_limited_accounts_hint": "Teoranta ag modhnóirí freastalaí",
  "notifications.policy.filter_limited_accounts_title": "Cuntais mhodhnaithe",
  "notifications.policy.filter_new_accounts.hint": "Cruthaithe laistigh den {days, plural, one {lae amháin} two {# lá} few {# lá} many {# lá} other {# lá}}",
  "notifications.policy.filter_new_accounts_title": "Cuntais nua",
  "notifications.policy.filter_not_followers_hint": "Agus daoine a bhfuil siad ag leanúint ort le níos lú ná {days, plural, one {lae amháin} two {# lá} few {# lá} many {# lá} other {# lá}}",
  "notifications.policy.filter_not_followers_title": "Daoine nach leanann tú",
  "notifications.policy.filter_not_following_hint": "Go dtí go gceadaíonn tú iad de láimh",
  "notifications.policy.filter_not_following_title": "Daoine nach leanann tú",
  "notifications.policy.filter_private_mentions_hint": "Scagtha mura bhfuil sé mar fhreagra ar do lua féin nó má leanann tú an seoltóir",
  "notifications.policy.filter_private_mentions_title": "Tagairtí príobháideacha gan iarraidh",
  "notifications.policy.title": "Bainistigh fógraí ó…",
  "notifications_permission_banner.enable": "Ceadaigh fógraí ar an deasc",
  "notifications_permission_banner.how_to_control": "Chun fógraí a fháil nuair nach bhfuil Mastodon oscailte, cumasaigh fógraí deisce. Is féidir leat a rialú go beacht cé na cineálacha idirghníomhaíochtaí a ghineann fógraí deisce tríd an gcnaipe {icon} thuas nuair a bhíonn siad cumasaithe.",
  "notifications_permission_banner.title": "Ná caill aon rud go deo",
  "onboarding.follows.back": "Ar ais",
  "onboarding.follows.empty": "Ar an drochuair, ní féidir aon torthaí a thaispeáint faoi láthair. Is féidir leat triail a bhaint as cuardach nó brabhsáil ar an leathanach taiscéalaíochta chun teacht ar dhaoine le leanúint, nó bain triail eile as níos déanaí.",
  "onboarding.follows.next": "Ar Aghaidh: Socraigh do phróifíl",
  "onboarding.follows.search": "Cuardach",
  "onboarding.follows.title": "Lean daoine le tosú",
  "onboarding.profile.discoverable": "Déan mo phróifíl a fháil amach",
  "onboarding.profile.discoverable_hint": "Nuair a roghnaíonn tú infhionnachtana ar Mastodon, d’fhéadfadh do phoist a bheith le feiceáil i dtorthaí cuardaigh agus treochtaí, agus d’fhéadfaí do phróifíl a mholadh do dhaoine a bhfuil na leasanna céanna acu leat.",
  "onboarding.profile.display_name": "Ainm taispeána",
  "onboarding.profile.display_name_hint": "D’ainm iomlán nó d’ainm spraíúil…",
  "onboarding.profile.finish": "Críochnaigh",
  "onboarding.profile.note": "Bith",
  "onboarding.profile.note_hint": "Is féidir leat @ daoine eile a lua nó #hashtags…",
  "onboarding.profile.title": "Socrú próifíle",
  "onboarding.profile.upload_avatar": "Íosluchtaigh pictiúr próifíl",
  "onboarding.profile.upload_header": "Íoslódáil an ceanntásca próifíl",
  "password_confirmation.exceeds_maxlength": "Sáraíonn dearbhú pasfhocail uasfhad an phasfhocail",
  "password_confirmation.mismatching": "Ní hionann dearbhú pasfhocail",
  "picture_in_picture.restore": "Cuir é ar ais",
  "poll.closed": "Dúnta",
  "poll.refresh": "Athnuaigh",
  "poll.reveal": "Féach torthaí",
  "poll.total_people": "{count, plural, one {# duine} other {# duine}}",
  "poll.total_votes": "{count, plural, one {# vóta} other {# vóta}}",
  "poll.vote": "Vótáil",
  "poll.voted": "Vótáil tú don freagra seo",
  "poll.votes": "{votes, plural, one {# vóta} other {# vóta}}",
  "poll_button.add_poll": "Cruthaigh suirbhé",
  "poll_button.remove_poll": "Bain suirbhé",
  "privacy.change": "Athraigh príobháideacht postála",
  "privacy.direct.long": "Luaigh gach duine sa phost",
  "privacy.direct.short": "Tagairt phríobháideach",
  "privacy.private.long": "Do leanúna amháin",
  "privacy.private.short": "Leantóirí",
  "privacy.public.long": "Duine ar bith ar agus amach Mastodon",
  "privacy.public.short": "Poiblí",
  "privacy.quote.anyone": "{visibility}, ceadaítear comharthaí athfhriotail",
  "privacy.quote.disabled": "{visibility}, sleachta díchumasaithe",
  "privacy.quote.limited": "{visibility}, sleachta teoranta",
  "privacy.unlisted.additional": "Iompraíonn sé seo díreach mar a bheadh ​​poiblí, ach amháin ní bheidh an postáil le feiceáil i bhfothaí beo nó i hashtags, in iniúchadh nó i gcuardach Mastodon, fiú má tá tú liostáilte ar fud an chuntais.",
  "privacy.unlisted.long": "I bhfolach ó thorthaí cuardaigh Mastodon, treochtaí, agus amlínte poiblí",
  "privacy.unlisted.short": "Poiblí ciúin",
  "privacy_policy.last_updated": "Nuashonraithe {date}",
  "privacy_policy.title": "Polasaí príobháideachais",
  "quote_error.edit": "Ní féidir sleachta a chur leis agus post á chur in eagar.",
  "quote_error.poll": "Ní cheadaítear lua le pobalbhreitheanna.",
  "quote_error.private_mentions": "Ní cheadaítear lua le tagairtí díreacha.",
  "quote_error.quote": "Ní cheadaítear ach luachan amháin ag an am.",
  "quote_error.unauthorized": "Níl údarás agat an post seo a lua.",
  "quote_error.upload": "Ní cheadaítear lua a dhéanamh le ceangaltáin sna meáin.",
  "recommended": "Molta",
  "refresh": "Athnuaigh",
  "regeneration_indicator.please_stand_by": "Fan i do sheasamh, le do thoil.",
  "regeneration_indicator.preparing_your_home_feed": "Ag ullmhú do bheatha baile…",
  "relative_time.days": "{number}l",
  "relative_time.full.days": "{number, plural, one {# lá} other {# lá}} ó shin",
  "relative_time.full.hours": "{number, plural, one {# uair} other {# uair}} ó shin",
  "relative_time.full.just_now": "díreach anois",
  "relative_time.full.minutes": "{number, plural, one {# nóiméad} other {# nóiméad}} ó shin",
  "relative_time.full.seconds": "{number, plural, one {# soicind} other {# soicind}} ó shin",
  "relative_time.hours": "{number}u",
  "relative_time.just_now": "anois",
  "relative_time.minutes": "{number}n",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "inniu",
  "remove_quote_hint.button_label": "Tuigim é",
  "remove_quote_hint.message": "Is féidir leat é sin a dhéanamh ón roghchlár roghanna {icon}.",
  "remove_quote_hint.title": "Ar mhaith leat do phost luaite a bhaint?",
  "reply_indicator.attachments": "{count, plural, one {# alán} two {# aláin} few {# aláin} many {# aláin} other {# aláin}}",
  "reply_indicator.cancel": "Cealaigh",
  "reply_indicator.poll": "Vótaíocht",
  "report.block": "Bac",
  "report.block_explanation": "Ní fheicfidh tú a c(h)úid postálacha. Ní bheidh sé/sí in ann do chuid postálacha a fheiceáil ná tú féin a leanúint. Beidh sé/sí in ann a dhéanamh amach go bhfuil sé/sí bactha.",
  "report.categories.legal": "Dlíthiúil",
  "report.categories.other": "Eile",
  "report.categories.spam": "Turscar",
  "report.categories.violation": "Sáraíonn ábhar riail freastalaí amháin nó níos mó",
  "report.category.subtitle": "Roghnaigh an toradh is fearr",
  "report.category.title": "Inis dúinn cad atá ar siúl leis an {type} seo",
  "report.category.title_account": "próifíl",
  "report.category.title_status": "postáil",
  "report.close": "Déanta",
  "report.collection_comment": "Cén fáth ar mhaith leat an bailiúchán seo a thuairisciú?",
  "report.comment.title": "An bhfuil aon rud eile ba chóir dúinn a fhios agat, dar leat?",
  "report.forward": "Seol ar aghaidh chun {target}",
  "report.forward_hint": "Is ó fhreastalaí eile an cuntas. Cuir cóip gan ainm den tuarascáil ansin freisin?",
  "report.mute": "Balbhaigh",
  "report.mute_explanation": "Ní fheicfidh tú a postálacha. Is féidir an té seo tú a leanúint agus do phostálacha a fheiceáil, agus ní fhios go bhfuil iad balbhaithe.",
  "report.next": "An céad eile",
  "report.placeholder": "Ráitis bhreise",
  "report.reasons.dislike": "Ní maith liom é",
  "report.reasons.dislike_description": "Ní rud é ba mhaith leat a fheiceáil",
  "report.reasons.legal": "Tá sé mídhleathach",
  "report.reasons.legal_description": "Creideann tú go sáraíonn sé dlí do thíre nó do thír an fhreastalaí",
  "report.reasons.other": "Is rud eile é",
  "report.reasons.other_description": "Ní luíonn an cheist le catagóirí eile",
  "report.reasons.spam": "Is turscar é",
  "report.reasons.spam_description": "Naisc mhailíseacha, rannpháirtíocht bhréige, nó freagraí athchleachtach",
  "report.reasons.violation": "Sáraíonn sé rialacha an fhreastalaí",
  "report.reasons.violation_description": "Tá a fhios agat go sáraíonn sé rialacha ar leith",
  "report.rules.subtitle": "Roghnaigh gach atá i bhfeidhm",
  "report.rules.title": "Cén rialacha atá á sárú?",
  "report.statuses.subtitle": "Roghnaigh gach atá i bhfeidhm",
  "report.statuses.title": "An bhfuil aon phoist a thacaíonn leis an tuarascáil seo?",
  "report.submission_error": "Níorbh fhéidir an tuarascáil a chur isteach",
  "report.submission_error_details": "Seiceáil do nasc líonra agus déan iarracht arís ar ball.",
  "report.submit": "Cuir isteach",
  "report.target": "Ag tuairisciú {target}",
  "report.thanks.take_action": "Seo do roghanna chun an méid a fheiceann tú ar Mastodon a rialú:",
  "report.thanks.take_action_actionable": "Agus é seo á athbhreithniú againn, is féidir leat caingean a dhéanamh in aghaidh @{name}:",
  "report.thanks.title": "Ná bí ag iarraidh é seo a fheiceáil?",
  "report.thanks.title_actionable": "Go raibh maith agat as tuairisc a thabhairt, scrúdóimid é seo.",
  "report.unfollow": "Ná lean @{name}",
  "report.unfollow_explanation": "Tá tú ag leanúint an chuntais seo. Chun nach bhfeicfidh tú a bpoist i do fhotha baile a thuilleadh, dílean ​​iad.",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.legal": "Dlíthiúil",
  "report_notification.categories.legal_sentence": "ábhar mídhleathach",
  "report_notification.categories.other": "Eile",
  "report_notification.categories.other_sentence": "eile",
  "report_notification.categories.spam": "Turscar",
  "report_notification.categories.spam_sentence": "turscar",
  "report_notification.categories.violation": "Sárú rialach",
  "report_notification.categories.violation_sentence": "sárú riail",
  "report_notification.open": "Oscail tuairisc",
  "search.clear": "Glan an cuardach",
  "search.no_recent_searches": "Níl aon chuardach le déanaí",
  "search.placeholder": "Cuardaigh",
  "search.quick_action.account_search": "Próifílí a mheaitseálann {x}",
  "search.quick_action.go_to_account": "Téigh go próifíl {x}",
  "search.quick_action.go_to_hashtag": "Téigh chuig hashtag {x}",
  "search.quick_action.open_url": "Oscail URL i Mastodon",
  "search.quick_action.status_search": "Postálacha a mheaitseálann {x}",
  "search.search_or_paste": "Cuardaigh nó cuir URL isteach",
  "search_popout.full_text_search_disabled_message": "Níl sé ar fáil ar {domain}.",
  "search_popout.full_text_search_logged_out_message": "Ar fáil ach amháin nuair atá tú logáilte isteach.",
  "search_popout.language_code": "Cód teanga ISO",
  "search_popout.options": "Roghanna cuardaigh",
  "search_popout.quick_actions": "Gníomhartha tapa",
  "search_popout.recent": "Cuardach le déanaí",
  "search_popout.specific_date": "dáta ar leith",
  "search_popout.user": "úsáideoir",
  "search_results.accounts": "Próifílí",
  "search_results.all": "Gach",
  "search_results.hashtags": "Haischlib",
  "search_results.no_results": "Gan torthaí.",
  "search_results.no_search_yet": "Bain triail as postálacha, próifílí nó hashtags a chuardach.",
  "search_results.see_all": "Gach rud a fheicáil",
  "search_results.statuses": "Postálacha",
  "search_results.title": "Cuardaigh \"{q}\"",
  "server_banner.about_active_users": "Daoine a úsáideann an freastalaí seo le 30 lá anuas (Úsáideoirí Gníomhacha Míosúla)",
  "server_banner.active_users": "úsáideoirí gníomhacha",
  "server_banner.administered_by": "Arna riar ag:",
  "server_banner.is_one_of_many": "Tá {domain} ar cheann de na freastalaithe Mastodon neamhspleácha go leor is féidir leat a úsáid chun páirt a ghlacadh sa feiliúnach.",
  "server_banner.more_about_this_server": "Tuilleadh faoin bhfreastalaí seo",
  "server_banner.server_stats": "Staitisticí freastalaí:",
  "sign_in_banner.create_account": "Cruthaigh cuntas",
  "sign_in_banner.follow_anyone": "Lean aon duine ar fud an fhealsúnachta agus féach ar fad in ord croineolaíoch. Gan algartam, fógraí, nó clickbait i radharc.",
  "sign_in_banner.mastodon_is": "Is é Mastodon an bealach is fearr le coinneáil suas lena bhfuil ag tarlú.",
  "sign_in_banner.sign_in": "Sinigh isteach",
  "sign_in_banner.sso_redirect": "Logáil isteach nó Cláraigh",
  "skip_links.hotkey": "<span>Eochair Their</span> {hotkey}",
  "skip_links.skip_to_content": "Léim go dtí an príomhábhar",
  "skip_links.skip_to_navigation": "Léim go dtí an príomh-loingseoireacht",
  "status.admin_account": "Oscail comhéadan modhnóireachta do @{name}",
  "status.admin_domain": "Oscail comhéadan modhnóireachta le haghaidh {domain}",
  "status.admin_status": "Oscail an postáil seo sa chomhéadan modhnóireachta",
  "status.all_disabled": "Tá treisiúcháin agus sleachta díchumasaithe",
  "status.block": "Bac @{name}",
  "status.bookmark": "Leabharmharcanna",
  "status.cancel_reblog_private": "Dímhol",
  "status.cannot_quote": "Ní cheadaítear duit an post seo a lua",
  "status.cannot_reblog": "Ní féidir an phostáil seo a mholadh",
  "status.contains_quote": "Tá luachan ann",
  "status.context.loading": "Ag lódáil tuilleadh freagraí",
  "status.context.loading_error": "Níorbh fhéidir freagraí nua a lódáil",
  "status.context.loading_success": "Freagraí nua luchtaithe",
  "status.context.more_replies_found": "Tuilleadh freagraí aimsithe",
  "status.context.retry": "Déan iarracht arís",
  "status.context.show": "Taispeáin",
  "status.continued_thread": "Snáithe ar lean",
  "status.copy": "Cóipeáil an nasc chuig an bpostáil",
  "status.delete": "Scrios",
  "status.delete.success": "Scriosadh an post",
  "status.detailed_status": "Amharc comhrá mionsonraithe",
  "status.direct": "Luaigh @{name} go príobháideach",
  "status.direct_indicator": "Lua príobháideach",
  "status.edit": "Cuir in eagar",
  "status.edited": "Arna chuir in eagar anuas {date}",
  "status.edited_x_times": "Curtha in eagar {count, plural, one {{count} uair amháin} two {{count} uair} few {{count} uair} many {{count} uair} other {{count} uair}}",
  "status.embed": "Faigh cód leabú",
  "status.favourite": "Is fearr leat",
  "status.favourites_count": "{count, plural,\n    one {{counter} cheanán}\n    two {{counter} cheanáin}\n    few {{counter} ceanáin}\n    many {{counter} ceanán}\n    other {{counter} ceanáin}\n}",
  "status.filter": "Déan scagadh ar an bpostáil seo",
  "status.history.created": "Chruthaigh {name} {date}",
  "status.history.edited": "Curtha in eagar ag {name} in {date}",
  "status.load_more": "Lódáil a thuilleadh",
  "status.media.open": "Cliceáil chun oscailt",
  "status.media.show": "Cliceáil chun a thaispeáint",
  "status.media_hidden": "Cuirtear meáin i bhfolach",
  "status.mention": "Luaigh @{name}",
  "status.more": "Tuilleadh",
  "status.mute": "Balbhaigh @{name}",
  "status.mute_conversation": "Balbhaigh comhrá",
  "status.open": "Leathnaigh an post seo",
  "status.pin": "Pionnáil ar do phróifíl",
  "status.quote": "Luachan",
  "status.quote.cancel": "Cealaigh an luachan",
  "status.quote_error.blocked_account_hint.title": "Tá an post seo i bhfolach mar gur chuir tú bac ar @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Tá an post seo i bhfolach mar gur chuir tú bac ar {domain}.",
  "status.quote_error.filtered": "I bhfolach mar gheall ar cheann de do scagairí",
  "status.quote_error.limited_account_hint.action": "Taispeáin ar aon nós",
  "status.quote_error.limited_account_hint.title": "Tá an cuntas seo i bhfolach ag modhnóirí {domain}.",
  "status.quote_error.muted_account_hint.title": "Tá an post seo i bhfolach mar gur chuir tú @{name} ar neamhní.",
  "status.quote_error.not_available": "Níl an postáil ar fáil",
  "status.quote_error.pending_approval": "Post ar feitheamh",
  "status.quote_error.pending_approval_popout.body": "Ar Mastodon, is féidir leat a rialú an féidir le duine tú a lua nó nach féidir. Tá an post seo ar feitheamh fad is atá ceadú an údair bhunaidh á fháil againn.",
  "status.quote_error.revoked": "Post bainte ag an údar",
  "status.quote_followers_only": "Ní féidir ach le leantóirí an post seo a lua",
  "status.quote_manual_review": "Déanfaidh an t-údar athbhreithniú de láimh",
  "status.quote_noun": "Luachan",
  "status.quote_policy_change": "Athraigh cé a fhéadann luachan a thabhairt",
  "status.quote_post_author": "Luaigh mé post le @{name}",
  "status.quote_private": "Ní féidir poist phríobháideacha a lua",
  "status.quotes.empty": "Níl an post seo luaite ag aon duine go fóill. Nuair a dhéanann duine é, taispeánfar anseo é.",
  "status.quotes.local_other_disclaimer": "Ní thaispeánfar sleachta ar dhiúltaigh an t-údar dóibh.",
  "status.quotes.remote_other_disclaimer": "Níl ráthaíocht ann go dtaispeánfar anseo ach sleachta ó {domain}. Ní thaispeánfar sleachta ar dhiúltaigh an t-údar dóibh.",
  "status.quotes_count": "{count, plural, one {{counter} sleacht} two {{counter} sleachta} few {{counter} sleachta} many {{counter} sleachta} other {{counter} sleachta}}",
  "status.read_more": "Léan a thuilleadh",
  "status.reblog": "Treisiú",
  "status.reblog_or_quote": "Borradh nó luachan",
  "status.reblog_private": "Roinn arís le do leanúna",
  "status.reblogged_by": "Mhol {name}",
  "status.reblogs.empty": "Níor mhol éinne an phostáil seo fós. Nuair a mholfaidh duine éigin í, taispeánfar anseo é sin.",
  "status.reblogs_count": "{count, plural,\n    one {{counter} athfhriotal}\n    two {{counter} athfhriotail}\n    few {{counter} athfhriotail}\n    many {{counter} athfhriotal}\n    other {{counter} athfhriotail}\n}",
  "status.redraft": "Scrios ⁊ athdhréachtaigh",
  "status.remove_bookmark": "Bain leabharmharc",
  "status.remove_favourite": "Bain ó cheanáin",
  "status.remove_quote": "Bain",
  "status.replied_in_thread": "D'fhreagair sa snáithe",
  "status.replied_to": "D'fhreagair {name}",
  "status.reply": "Freagair",
  "status.replyAll": "Freagair le snáithe",
  "status.report": "Tuairiscigh @{name}",
  "status.request_quote": "Iarratas ar luachan",
  "status.revoke_quote": "Bain mo phost ó phost @{name}",
  "status.sensitive_warning": "Ábhar íogair",
  "status.share": "Comhroinn",
  "status.show_less_all": "Taispeáin níos lú d'uile",
  "status.show_more_all": "Taispeáin níos mó d'uile",
  "status.show_original": "Taispeáin bunchóip",
  "status.title.with_attachments": "{user} a sheol {attachmentCount, plural, one {ceangal} two {{attachmentCount} ceangal} few {{attachmentCount} ceangail} many {{attachmentCount} ceangal} other {{attachmentCount} ceangal}}",
  "status.translate": "Aistrigh",
  "status.translated_from_with": "D'Aistrigh ón {lang} ag úsáid {provider}",
  "status.uncached_media_warning": "Níl an réamhamharc ar fáil",
  "status.unmute_conversation": "Díbhalbhaigh comhrá",
  "status.unpin": "Díphionnáil de do phróifíl",
  "subscribed_languages.lead": "Ní bheidh ach postálacha i dteangacha roghnaithe le feiceáil ar do bhaile agus liostaí amlínte tar éis an athraithe. Roghnaigh ceann ar bith chun postálacha a fháil i ngach teanga.",
  "subscribed_languages.save": "Sábháil athruithe",
  "subscribed_languages.target": "Athraigh teangacha suibscríofa le haghaidh {target}",
  "tabs_bar.home": "Baile",
  "tabs_bar.menu": "Roghchlár",
  "tabs_bar.notifications": "Fógraí",
  "tabs_bar.publish": "Post Nua",
  "tabs_bar.search": "Cuardaigh",
  "tag.remove": "Bain",
  "terms_of_service.effective_as_of": "I bhfeidhm ó {date}",
  "terms_of_service.title": "Téarmaí Seirbhíse",
  "terms_of_service.upcoming_changes_on": "Athruithe atá le teacht ar {date}",
  "time_remaining.days": "{number, plural, one {# lá} other {# lá}} fágtha",
  "time_remaining.hours": "{number, plural, one {# uair} other {# uair}} fágtha",
  "time_remaining.minutes": "{number, plural, one {# nóiméad} other {# nóiméad}} fágtha",
  "time_remaining.moments": "Chuimhneacháin fágtha",
  "time_remaining.seconds": "{number, plural, one {# soicind} other {# soicind}} fágtha",
  "trends.counter_by_accounts": "{count, plural, one {{counter} duine} other {{counter} duine}} le {days, plural, one {lá} other {{days} lá}} anuas",
  "trends.trending_now": "Ag treochtáil anois",
  "ui.beforeunload": "Caillfear do dhréacht má fhágann tú Mastodon.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}k",
  "upload_area.title": "Tarraing ⁊ scaoil chun uaslódáil",
  "upload_button.label": "Cuir íomhánna, físeán nó comhad fuaime leis",
  "upload_error.limit": "Sáraíodh an teorainn uaslódála comhaid.",
  "upload_error.poll": "Ní cheadaítear uaslódáil comhad le pobalbhreith.",
  "upload_error.quote": "Ní cheadaítear uaslódáil comhaid le sleachta.",
  "upload_form.drag_and_drop.instructions": "Chun ceangaltán meán a phiocadh suas, brúigh spás nó cuir isteach. Agus tú ag tarraingt, bain úsáid as na heochracha saigheada chun an ceangaltán meán a bhogadh i dtreo ar bith. Brúigh spás nó cuir isteach arís chun an ceangaltán meán a scaoileadh ina phost nua, nó brúigh éalú chun cealú.",
  "upload_form.drag_and_drop.on_drag_cancel": "Cuireadh an tarraingt ar ceal. Scaoileadh ceangaltán meán {item}.",
  "upload_form.drag_and_drop.on_drag_end": "Scaoileadh ceangaltán meán {item}.",
  "upload_form.drag_and_drop.on_drag_over": "Bogadh ceangaltán meán {item}.",
  "upload_form.drag_and_drop.on_drag_start": "Roghnaíodh ceangaltán meán {item}.",
  "upload_form.edit": "Cuir in eagar",
  "upload_progress.label": "Ag uaslódáil...",
  "upload_progress.processing": "Ag próiseáil…",
  "username.taken": "Glactar leis an ainm úsáideora sin. Bain triail eile as",
  "video.close": "Dún físeán",
  "video.download": "Íoslódáil comhad",
  "video.exit_fullscreen": "Scoir scáileán iomlán",
  "video.expand": "Leath físeán",
  "video.fullscreen": "Lánscáileán",
  "video.hide": "Cuir físeán i bhfolach",
  "video.mute": "Balbhaigh",
  "video.pause": "Cuir ar sos",
  "video.play": "Cuir ar siúl",
  "video.skip_backward": "Scipeáil siar",
  "video.skip_forward": "Scipeáil ar aghaidh",
  "video.unmute": "Díbhalbhú",
  "video.volume_down": "Toirt síos",
  "video.volume_up": "Toirt suas",
  "visibility_modal.button_title": "Socraigh infheictheacht",
  "visibility_modal.direct_quote_warning.text": "Má shábhálann tú na socruithe reatha, déanfar an luachan leabaithe a thiontú ina nasc.",
  "visibility_modal.direct_quote_warning.title": "Ní féidir sleachta a leabú i dtráchtanna príobháideacha",
  "visibility_modal.header": "Infheictheacht agus idirghníomhaíocht",
  "visibility_modal.helper.direct_quoting": "Ní féidir le daoine eile tráchtanna príobháideacha a scríobhadh ar Mastodon a lua.",
  "visibility_modal.helper.privacy_editing": "Ní féidir infheictheacht a athrú tar éis post a fhoilsiú.",
  "visibility_modal.helper.privacy_private_self_quote": "Ní féidir féin-sleachta ó phoist phríobháideacha a chur ar fáil don phobal.",
  "visibility_modal.helper.private_quoting": "Ní féidir le daoine eile poist atá scríofa ar Mastodon agus atá dírithe ar leanúna amháin a lua.",
  "visibility_modal.helper.unlisted_quoting": "Nuair a luann daoine thú, beidh a bpost i bhfolach ó amlínte treochta freisin.",
  "visibility_modal.instructions": "Rialaigh cé a fhéadfaidh idirghníomhú leis an bpost seo. Is féidir leat socruithe a chur i bhfeidhm ar gach post amach anseo trí nascleanúint a dhéanamh chuig <link>Sainroghanna > Réamhshocruithe Postála</link>.",
  "visibility_modal.privacy_label": "Infheictheacht",
  "visibility_modal.quote_followers": "Leantóirí amháin",
  "visibility_modal.quote_label": "Cé a fhéadfaidh lua",
  "visibility_modal.quote_nobody": "Mise amháin",
  "visibility_modal.quote_public": "Aon duine",
  "visibility_modal.save": "Sábháil"
}
